export default {
  // Groups
  'groups.dropdown.name': `Groupe {number} de {mentorFullName}`,
  'groups.dropdown.newGroup': 'Rechercher un nouveau groupe de mentorat',
  'groups.settingsModal.title': `Paramètres du groupe de mentorat 🛠️`,
  'groups.settingsModal.name.label': `Nom du groupe`,
  'groups.settingsModal.name.placeholder': `Nom du groupe`,
  'groups.settingsModal.success': `Les paramètres du groupe ont été mis à jour avec succès !`,

  // Admin dashboard
  'admin.dashboard.loading': `Chargement du tableau de bord...`,
  'admin.dashboard.unavailable': `Le tableau de bord n'est pas disponible pour ce programme.`,
  'admin.dashboard.feedback.title': `Suivi des sessions`,
  'admin.dashboard.general.title': `Participants`,
  'admin.dashboard.sessions.title': `Suivi des sessions`,
  'admin.dashboard.feedback.sessionsPerGroupGoal': `Objectif de sessions par groupe`,
  'admin.dashboard.feedback.finishedSessions': `Sessions terminées`,
  'admin.dashboard.feedback.totalReviews': `Nombre d'avis total`,
  'admin.dashboard.common.nbMentors': `%*mentor*%s`,
  'admin.dashboard.common.nbMentees': `%*mentee*%s`,
  'admin.dashboard.common.nbGroups': `Groupes`,
  'admin.dashboard.common.nbMenteesPerMentor': `Taux de %*mentee*%s par %*mentor*%`,
  'admin.dashboard.feedback.averageSessionsRating': `Moyenne des notes de session`,
  'admin.dashboard.feedback.mentorsThatLeaveFeedback': `%*mentor*%s ayant laissé un avis`,
  'admin.dashboard.feedback.menteesThatLeaveFeedback': `%*mentee*%s ayant laissé un avis`,
  'admin.dashboard.matching.title': `Suivi des mises en relation`,
  'admin.dashboard.matching.nbMatching': `Nombre de mises en relation`,
  'admin.dashboard.matching.ofGoalReached': `De l'objectif atteint`,

  // Admin groups
  'admin.groups.addGroup': 'Créer un groupe',
  'admin.groups.table.header.name': 'Nom',
  'admin.groups.table.header.mentor': '%*mentor*%',
  'admin.groups.table.header.mentees': '%*mentee*%s',
  'admin.groups.table.header.finishedSessions': 'Sessions terminées',
  'admin.groups.table.header.actions': 'Actions',
  'admin.groups.table.nbMentees.value.any': 'Tout nombre de %*mentee*%s',
  'admin.groups.table.nbMentees.value': `Avec {count} %*mentee*% | Avec {count} %*mentee*%s`,
  'admin.groups.groupStructureModal.existing.title': `Ajouter ou supprimer<br/>des utilisateurs de ce groupe 👥`,
  'admin.groups.groupStructureModal.new.title': `Créer un nouveau groupe<br/>de mentorat 👥`,
  'admin.groups.groupStructureModal.body.addManager': `Ajouter un manager`,
  'admin.groups.groupStructureModal.body.addMentor': `Ajouter un %*mentor*%`,
  'admin.groups.groupStructureModal.body.addMentee': `Ajouter un %*mentee*%`,
  'admin.groups.groupStructureModal.new.sucess': `Le groupe a été créé avec succès !`,
  'admin.groups.groupStructureModal.existing.sucess': `Le groupe a été mis à jour avec succès !`,
  'admin.groups.groupStructureModal.matching.title': `Analyse de la mise en relation :`,
  'admin.groups.matchingSuggestions.searching': `Recherche de mentors compatibles...`,
  'admin.groups.matchingSuggestions.searchingMentees': `Recherche de mentorés compatibles...`,
  'admin.groups.matchingSuggestions.title': `{count} mentor compatible trouvé | {count} mentors compatibles trouvés`,
  'admin.groups.matchingSuggestions.titleMentees': `{count} mentoré compatible trouvé | {count} mentorés compatibles trouvés`,
  'admin.groups.matchingSuggestions.compatible': `compatible`,
  'admin.groups.matchingSuggestions.selectButton': `Sélectionner ce mentor`,
  'admin.groups.matchingSuggestions.selectMentor': `Sélectionner ce mentor`,
  'admin.groups.matchingSuggestions.selectMentee': `Sélectionner ce mentoré`,
  'admin.groups.matchingSuggestions.manualSearch': `ou rechercher manuellement`,
  'admin.groups.matchingSuggestions.noGroup': `Aucun groupe`,
  'admin.groups.matchingSuggestions.groupCount': `{count} groupe | {count} groupes`,

  // Admin Settings
  'admin.settings.form.colorContrast.warning':
    'Cette couleur n’atteint pas le contraste 4,5:1 requis (WCAG 1.4.3) — actuellement {ratio}:1. Proposition :',
  'admin.settings.form.colorContrast.accept': 'Utiliser cette couleur',

  // Admin Reminders
  'admin.reminders.cycle-periods': 'Période de relance du {startDate} au {endDate}',
  'admin.reminders.reminderStructureModal.new.title': `Créer un nouveau cycle<br/>de relances 📅`,
  'admin.reminders.reminderStructureModal.existing.title': `Ajouter ou supprimer<br/>des relances 📅`,
  'admin.reminders.addReminder': `Créer une relance`,
  'reminder.newReminderModal.generalInformation.input.name.label': `Nom de la relance`,
  'reminder.newReminderModal.generalInformation.input.name.placeholder': `Entrer un nom pour cette relance`,
  'reminder.newReminderModal.generalInformation.input.program.label': `Programme`,
  'reminder.newReminderModal.generalInformation.input.type.label': `Type de la relance`,
  'reminder.newReminderModal.generalInformation.input.type.placeholder': `Selectionner un type de relance`,
  'reminder.newReminderModal.generalInformation.input.start-date.label': `Date de début`,
  'reminder.newReminderModal.generalInformation.input.start-date.placeholder': `12-03-2024`,
  'admin.reminders.reminderStructureModal.startDate.error': `La date de début ne peut pas être modifiée car ce cycle de relances a déjà commencé.`,
  'reminder.newReminderModal.generalInformation.input.end-date.label': `Date de fin`,
  'reminder.newReminderModal.generalInformation.input.end-date.placeholder': `12-03-2024`,
  'reminder.newReminderModal.generalInformation.input.reminder-date.label': `Date de la relance`,
  'reminder.newReminderModal.generalInformation.input.reminder-date.placeholder': `12-03-2024`,
  'reminder.newReminderModal.generalInformation.buton.reminder-date': `Ajouter cette date`,
  'admin.newReminderModal.submit': `Créer la relance`,
  'admin.updateReminderModal.submit': `Modifier la relance`,
  'admin.reminders.reminderStructureModal.new.success': `Le cycle de relances a été créé avec succès !`,
  'admin.reminders.reminderStructureModal.update.success': `Le cycle de relances a été mis à jour avec succès !`,
  'admin.reminders.reminderStructureModal.delete.success': `Le cycle de relances a été supprimé avec succès !`,
  'admin.reminders.delete.confirmation.title': `Êtes-vous sûr de vouloir supprimer ce cycle ?`,
  'admin.reminders.delete.confirmation.content': `Cette action est irréversible et supprimera également tous les reminders associés.`,

  // admin users
  'admin.users.manualInvitationModal.title': `Invitation manuelle d'un utilisateur<br/>à partir de son e-mail 📧`,
  'admin.users.manualInvitationModal.alreadyInsideProgram': `Cet utilisateur est déjà dans le programme.`,
  'admin.users.manualInvitationModal.add': `Ajouter dans ce programme`,
  'admin.users.manualInvitationModal.invite': `Envoyer l'invitation`,
  'admin.users.manualInvitationModal.invitation.success': `L'invitation a été envoyée avec succès !`,
  'admin.users.manualInvitationModal.add.success': `L'utilisateur a été ajouté avec succès !`,
  'admin.users.listing.searchPlaceholder': `E-mail, nom, prénom...`,
  'admin.users.listing.all': `Tous`,
  'admin.users.listing.withGroup': `Avec groupe`,
  'admin.users.listing.withoutGroup': `Sans groupe`,
  'admin.users.listing.withOrWithoutGroup': `Avec/sans groupe`,
  'admin.users.excelConfirmationModal.addUser': `Ajouter`,
  'admin.users.excelConfirmationModal.title': `L'importation est-elle <br/>correcte ? 👥️`,
  'admin.users.excelConfirmationModal.key.email': `E-mail`,
  'admin.users.excelConfirmationModal.key.firstname': `Prénom`,
  'admin.users.excelConfirmationModal.key.lastname': `Nom`,
  'admin.users.excelConfirmationModal.key.role': `Rôle`,
  'admin.users.excelConfirmationModal.key.language': `Langue`,
  'admin.users.excelConfirmationModal.key.programId': `Programme`,
  'admin.users.excelConfirmationModal.key.phone': `Téléphone`,
  'admin.users.excelConfirmationModal.key.matchingCriteria': `Critères de mise en relation`,
  'admin.users.excelConfirmationModal.key.sso': `Authentification unique (SSO)`,
  'admin.users.excelConfirmationModal.key.description': `Description du profil`,
  'admin.users.excelConfirmationModal.success': `Les utilisateurs ont été importés avec succès !`,
  'admin.users.excelImportModal.title': `Importation d'utilisateurs<br/>depuis un fichier Excel 📂`,
  'admin.users.import.confirmation.title': `Vous allez ajouter "{menteeName}"<br/>dans le programme "{programName}"`,
  'admin.users.excelImportModal.importation.inProgress': `Importation en cours...`,
  'admin.users.excelImportModal.file.valid': `Fichier valide`,
  'admin.users.excelImportModal.instructions.title': `Comment dois-je structurer mon fichier Excel ?`,
  'admin.users.excelImportModal.instructions.body.part1': `Merci de télécharger le  `,
  'admin.users.excelImportModal.instructions.body.linkToTheGuide': `notre guide`,
  'admin.users.excelImportModal.instructions.body.part2': ` à remplir pour l'importation de vos utilisateurs. Pour plus d'informations sur la structure du fichier, vous pouvez consulter `,
  'admin.users.excelImportModal.instructions.body.downloadExcel': `template préformater`,
  'admin.users.excelImportModal.instructions.body.sentenceFileImport': `Importation d'utilisateurs programme`,
  'admin.users.excelImportModal.error.invalidEmailFor': `L'e-mail est invalide pour {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.invalidEmailForOne': `Certains e-mails sont invalides.`,
  'admin.users.excelImportModal.error.invalidUUID': `Le champ {field} contient un UUID invalide : {uuid}`,
  'admin.users.excelImportModal.error.invalidPhoneFor': `Le numéro de téléphone est invalide pour {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingColumns': `Une ou plusieurs colonnes sont manquantes`,
  'admin.users.excelImportModal.error.missingEmailFor': `L'e-mail est manquant pour {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingEmailForOne': `Certains e-mails sont manquants.`,
  'admin.users.excelImportModal.error.invalidRoleForOne': `Certains rôles sont invalides.`,
  'admin.users.excelImportModal.error.invalidRoleFor': `Le rôle est invalide pour {firstName} {lastName}.`,
  'admin.users.excelImportModal.error.missingRoleForOne': `Certains rôles sont manquants.`,
  'admin.users.excelImportModal.error.missingRoleFor': `Le rôle est manquant pour {firstName} {lastName}.`,
  'admin.users.excelImportModal.validStructure': `La structure du fichier est valide`,
  'admin.users.user.inAGroup': `Dans un groupe`,
  'admin.users.user.superAdmin': `Super admin`,
  'admin.users.user.withoutGroup': `Sans groupe`,
  'admin.users.table.header.user': `Utilisateur`,
  'admin.users.table.header.role': `Rôle`,
  'admin.users.table.header.group': `Groupe`,
  'admin.users.table.header.actions': `Actions`,
  'moreActions.user.loginMethod.sso': 'Connexion : SSO',
  'moreActions.user.loginMethod.password': 'Connexion : e-mail + mot de passe',
  'moreActions.user.loginMethod.pending': 'Connexion : invitation en attente',
  'moreActions.user.switchToSsoLogin': 'Passer en SSO',
  'moreActions.user.switchToSsoLogin.confirmTitle': 'Passer ce compte en SSO ?',
  'moreActions.user.switchToSsoLogin.confirmLabel':
    "Cette personne se connectera avec le compte de son établissement, sur son adresse e-mail actuelle. Son mot de passe ne fonctionnera plus. Si cette adresse n'est pas celle de l'établissement (une adresse Gmail, par exemple), elle ne pourra plus se connecter.",
  'moreActions.user.switchToSsoLogin.success':
    'Le compte se connecte maintenant par SSO. Sur la page de connexion, la personne utilisera le bouton de son établissement.',
  'moreActions.user.switchToSsoLogin.alreadySso': 'Ce compte se connecte déjà par SSO.',
  'moreActions.user.switchToSsoLogin.ssoDisabled': "Le SSO n'est pas activé sur cette plateforme.",
  'moreActions.user.switchToSsoLogin.identityInUse':
    "Un autre compte est déjà rattaché au SSO avec cette adresse. Contactez l'équipe Constel.",
  'admin.users.table.empty': `Aucun utilisateur trouvé.`,
  'admin.users.editUserModal.title': `Modifier l'utilisateur`,
  'admin.users.editUserModal.save': `Enregistrer les modifications`,
  'admin.users.editUserModal.success': `L'utilisateur a été mis à jour avec succès !`,
  'admin.users.editUserModal.confirmation.title': `Mettre à jour {userName} ?`,
  'admin.users.editUserModal.email.hint': `Corrigez l'adresse en cas de faute de frappe : l'utilisateur se connectera avec la nouvelle.`,
  'admin.users.editUserModal.email.alreadyUsed': `Cette adresse est déjà utilisée par un autre compte`,
  'admin.users.editUserModal.email.reserved': `Les adresses de l'équipe Constel ne peuvent être données ou modifiées que par l'équipe Constel`,
  'admin.users.editUserModal.rolesLocked': `Les rôles admin et support d'un super admin se gèrent depuis « Ma plateforme »`,
  'admin.users.editUserModal.superAdminHint': `Super admin : seuls les rôles mentor et mentoré se modifient ici.`,

  // Admin Reminders
  'admin.reminders.title': `Relances`,

  // Matching
  'matching.newMatchingModal.matchingInformation.title': `Rechercher un<br/>nouveau groupe de mentorat 🧑‍🏫`,
  'matching.newMatchingModal.matchingInformation.bodyInformation': `
        <span>
        <strong>Vous souhaitez être mis en relation avec un nouveau %*mentor*% pour approfondir vos connaissances sur un autre
            sujet ?</strong>
        </span>
        <br />
        <br />
        <span>Cliquez sur continuer et renseignez vos nouveaux critères de mise en relation.</span>
  `,
  'matching.newMatchingModal.fillCriteria.title': `Renseignez vos nouveaux<br/>critères de mise en relation 🔎`,
  'matching.newMatchingModal.fillCriteria.bodyInformation': `
         <span>
          <strong>
            Aidez-nous à vous matcher avec le %*mentor*% qui vous correspond le plus en remplissant ces critères :
          </strong>
        </span>
        <br/>
        <span>
            Note: Votre %*mentor*% pourra voir ces critères.
        </span>
        `,
  'matching.newMatchingModal.fillCriteria.button.lookForMentor': `Rechercher un %*mentor*%`,
  'matching.newmatchingModal.fillCriteria.error.noAvailableMentor': `Aucun %*mentor*% n'est disponible pour le moment. Veuillez réessayer plus tard.`,
  'matching.menteeMatchingLoading.title': `Nous recherchons les %*mentor*%s les plus<br/>adaptés à votre profil...`,
  'matching.menteeMatchingLoading.steps.0': `Analyse de votre profil...`,
  'matching.menteeMatchingLoading.steps.1': `Recherche des %*mentor*%s compatibles...`,
  'matching.menteeMatchingLoading.steps.2': `Évaluation des correspondances...`,
  'matching.menteeMatchingLoading.steps.3': `Comparaison des profils...`,
  'matching.menteeMatchingLoading.steps.4': `Classement des meilleurs résultats...`,
  'matching.menteeMatchingLoading.steps.5': `Vérification des disponibilités...`,
  'matching.menteeMatchingLoading.steps.6': `Optimisation des recommandations...`,
  'matching.menteeMatchingLoading.steps.7': `Affinement des suggestions...`,
  'matching.menteeMatchingLoading.steps.8': `Préparation de vos résultats...`,
  'matching.menteeMatchingLoading.steps.9': `Finalisation, plus que quelques instants...`,
  'matching.menteeMatchingLoading.steps.10': `Presque terminé, merci de votre patience...`,
  'matching.menteeMatchingLoading.steps.11': `Derniers ajustements en cours...`,
  'matching.newMatchingModal.confirmation.title': `Voici nos recommandations 🎉`,
  'matching.newMatchingModal.confirmation.headerSubInfo': `Si vous acceptez ce nouveau %*mentor*%, vous serez placé dans un nouveau groupe de mentorat et vous conserverez tous les autres.`,
  'matching.newMatchingModal.confirmation.cancel': `Vous avez annulé la mise en relation avec ce %*mentor*%.`,
  'matching.newMatchingModal.confirmation.success': 'Vous avez été mis en relation avec un nouveau %*mentor*% !',
  'matching.newMatchingModal.confirmation.error':
    "Vous ne pouvez pas être mise en relation pour le moment, merci d'attendre quelques minutes",

  'matching.matchingCriteria': 'Critères de mise en relation',
  'matching.mentorDescription': 'Description du mentor',
  'matching.findMentor': 'Trouver un mentor',
  'matching.newMatchingModal.confirmation.loadingProfile': `Chargement du profil du %*mentor*%...`,
  'matching.newMatchingModal.confirmation.loadingProfile.error': `Une erreur est survenue lors du chargement du profil du %*mentor*%.`,
  'matching.newMatchingModal.confirmation.button.accept': `Choisir ce %*mentor*%`,
  'matching.newMatchingModal.confirmation.button.change': `Relancer une recherche`,
  'matching.noMentorFoundModal.title': `Nous n'avons pas trouvé de mentor correspondant à votre demande 🤷`,
  'matching.noMentorFoundModal.button.restartResearch': `Relancer une recherche`,
  'matching.noMentorFoundModal.body.part1.1': `<strong>Votre recherche n'a pas aboutie.</strong>`,
  'matching.noMentorFoundModal.body.part2.1': `Relancer une recherche en affinant vos critères.`,
  'matching.noMentorFoundModal.body.part1.2': `<strong>La recherche n'a donné aucun résultat.</strong>`,
  'matching.noMentorFoundModal.body.part2.2': `Relancer une recherche en utilisant des critères plus larges.`,
  'matching.noMentorFoundModal.body.part1.3': `<strong>Rassurez-vous, votre demande à été prise en charge.</strong><br/>Vous serez contacté prochainement afin que l'on vous aide dans vos démarches.`,
  'matching.noMentorFoundModal.body.part2.3': `Pour optimiser les résultats, nous vous recommandons tout de même de procéder à de nouvelles recherches afin d'élargir les possibilités de mise en relation.`,

  'matching.fillingCriterias.programDetails': `À propos du programme {program}`,
  'matching.fillingCriterias.mandatory.mentor.title': `Vos critères sont complets, il ne reste qu'à les valider ✅ | Encore {count} réponse pour recevoir vos %*mentee*%s 🎓 | Encore {count} réponses pour recevoir vos %*mentee*%s 🎓`,
  'matching.fillingCriterias.mandatory.mentee.title': `Vos critères sont complets, il ne reste qu'à les valider ✅ | Encore {count} réponse pour rencontrer votre %*mentor*% 🧑‍🏫 | Encore {count} réponses pour rencontrer votre %*mentor*% 🧑‍🏫`,
  'matching.fillingCriterias.mandatory.mentor.body': `Sans ces réponses, nous ne pouvons pas vous attribuer de %*mentee*%. Vos %*mentee*%s pourront voir ces critères.`,
  'matching.fillingCriterias.mandatory.mentee.body': `Sans ces réponses, nous ne pouvons pas vous mettre en relation avec un %*mentor*%. Votre %*mentor*% pourra voir ces critères.`,
  'matching.fillingCriterias.missingFields': `Il manque : {fields}`,
  'matching.fillingCriterias.validation.allFieldsRequired': `Tous les champs sont obligatoires. Il manque : {fields}`,
  'matching.fillingCriterias.mentor.title': `Vous n'avez pas encore de %*mentee*%s pour ce programme !🎓<br/>Remédions à cela !`,
  'matching.fillingCriterias.mentee.title': `Vous n'avez pas encore de %*mentor*% pour ce programme !🧑‍🏫<br/>Remédions à cela !`,
  'matching.fillingCriterias.mentor.body': `
        <span>
            Aidez-nous à vous matcher avec les %*mentee*%s qui vous correspondent le plus en remplissant ces critères :
        </span>
        <br/>
        <span>
            Note: Vos %*mentee*%s pourront voir ces critères.
        </span>
        `,
  'matching.fillingCriterias.mentee.body': `
        <span>
            Aidez-nous à vous matcher avec le %*mentor*% qui vous correspond le plus en remplissant ces critères :
        </span>
        <br/>
        <span>
            Note: Votre %*mentor*% pourra voir ces critères.
        </span>
        `,
  'matching.fillingCriterias.button.fillCriterias': `Valider mes critères`,
  'matching.fillingCriterias.button.lookForMentor': `Rechercher un %*mentor*%`,
  'matching.fillingCriterias.button.saveCriteria': `Enregistrer mes critères`,
  'matching.fillingCriterias.success': `Vos critères de mise en relation ont été mis à jour avec succès !`,
  'matching.fillingCriterias.noMentorAvailable': `Aucun %*mentor*% n'est disponible pour le moment. Veuillez réessayer plus tard.`,
  'matching.fillingCriterias.noMentorMatching': `Aucun %*mentor*% ne correspond à vos critères de mise en relation. Veuillez réessayer plus tard.`,
  'matching.fillingCriterias.validation.atLeastOneField': `Veuillez remplir au moins un champ de matching.`,
  'matching.confirmMentorModal.text': `En continuant vous allez être assigné à {firstName} {lastName}`,
  'matching.confirmMentorModal.title': `Confirmation de votre choix`,

  // Dashboard
  'dashboard.mentor.programCriterias.title': `Vos critères de mise en relation mentor`,
  'dashboard.mentor.programCriterias.button.modifyCriterias': `Modifier`,
  'dashboard.mentor.programCriterias.button.addCriterias': `Renseigner mes critères`,
  'dashboard.mentor.programCriterias.empty.noCriterias': `Vous n'avez pas encore de critères de mise en relation`,
  'dashboard.mentor.programCriterias.noProgram': `Vous n'avez pas encore de programme de mentorat.`,
  'dashboard.mentor.programCriteriasModal.title': `Modifier mes critères de mise en relation ✏️`,
  'dashboard.mentor.programCriteriasModal.bodyInformation': `Modifiez vos critères si vous souhaitez ajuster les profils des %*mentee*%s avec lesquels vous pouvez être mis en relation.`,
  'dashboard.mentor.programCriteriasModal.noCriterias': `Vous n'avez pas encore de critères de mise en relation.`,
  'dashboard.mentor.programCriteriasModal.success': `Vos critères de mise en relation ont été mis à jour avec succès !`,

  // Dashboard Mentee Criterias
  'dashboard.mentee.programCriterias.title': `Vos critères de mise en relation %*mentee*%`,
  'dashboard.mentee.programCriterias.button.modifyCriterias': `Modifier`,
  'dashboard.mentee.programCriterias.button.addCriterias': `Renseigner mes critères`,
  'dashboard.mentee.programCriterias.empty.noCriterias': `Vous n'avez pas encore de critères de mise en relation`,
  'dashboard.mentee.programCriterias.noProgram': `Vous n'avez pas encore de programme de mentorat.`,
  'dashboard.mentee.programCriteriasModal.title': `Modifier mes critères de mise en relation ✏️`,
  'dashboard.mentee.programCriteriasModal.bodyInformation': `Modifiez vos critères si vous souhaitez ajuster les profils des %*mentor*%s avec lesquels vous pouvez être mis en relation.`,
  'dashboard.mentee.programCriteriasModal.noCriterias': `Vous n'avez pas encore de critères de mise en relation.`,
  'dashboard.mentee.programCriteriasModal.success': `Vos critères de mise en relation ont été mis à jour avec succès !`,

  // Dashboard Unified Matching Criterias (Accordion)
  'dashboard.matchingCriterias.title': `Vos critères de mise en relation`,
  'dashboard.matchingCriterias.mentorSection': `%*mentor*%`,
  'dashboard.matchingCriterias.menteeSection': `%*mentee*%`,
  'dashboard.matchingCriterias.button.modify': `Modifier`,
  'dashboard.matchingCriterias.button.add': `Renseigner mes critères`,
  'dashboard.matchingCriterias.empty.noCriterias': `Vous n'avez pas encore de critères de mise en relation`,

  'program.noProgramModal.title': `Vous n'avez pas encore de programme de mentorat.`,
  'program.noProgramModal.body': `Si vous pensez que cela devrait être le cas ou pour toute question, merci de nous contacter via le support.`,
  'program.noProgramModal.viewProfil': `Consulter mon profil`,

  // Admin Program settings
  'admin.programSettings.newProgram': 'Créer un nouveau programme',
  'admin.programSettings.title': 'Paramètres du programme',
  'admin.programSettings.section.general': 'Général',
  'admin.programSettings.programType.title': `Objectif du programme (équipe Constel)`,
  'admin.programSettings.programType.hint': `Visible et modifiable par l'équipe Constel uniquement. Il décide de ce que mesure le tableau de bord du client.`,
  'admin.programSettings.programType.label': `Type de programme`,
  'admin.programSettings.programType.save': `Enregistrer l'objectif`,
  'admin.programSettings.programType.saved': `Objectif du programme enregistré`,
  'admin.programSettings.programType.option.UNDECLARED': `Non déclaré`,
  'admin.programSettings.programType.option.MATCHING': `Mise en relation`,
  'admin.programSettings.programType.option.SESSIONS': `Parcours de sessions`,
  'admin.programSettings.programType.option.CURRICULUM': `Cursus noté`,
  'admin.programSettings.programType.option.ON_DEMAND': `À la demande`,
  'admin.programSettings.programType.description.UNDECLARED': `Le tableau de bord reprend le type d'après le nom du programme, sinon il affiche « objectif à déclarer ».`,
  'admin.programSettings.programType.description.MATCHING': `Le programme livre un binôme qui se parle : on mesure les mentorés en contact avec leur mentor dans le mois qui suit la mise en relation, et les demandes servies en 30 jours.`,
  'admin.programSettings.programType.description.SESSIONS': `Chaque binôme tient le nombre de sessions prévu : on mesure le démarrage à 45 jours, la continuité et le rythme au regard du barème.`,
  'admin.programSettings.programType.description.CURRICULUM': `Les sessions sont imposées par un cursus et notées : on mesure les mentorés notés à chaque session.`,
  'admin.programSettings.programType.description.ON_DEMAND': `Une consultation ponctuelle, sans rythme prévu : on suit les porteurs reçus dans les 90 jours, sans couleur.`,
  'admin.programSettings.section.chat': 'Chat',
  'admin.programSettings.section.chatModeration': 'Modération du chat',
  'admin.programSettings.section.groups': 'Composition des groupes',
  'admin.programSettings.section.matching': 'Matching (mise en relation)',
  'admin.programSettings.section.session': 'Session',
  'admin.programSettings.section.branding': 'Image de marque et apparence',
  'admin.programSettings.section.branding.description':
    'Ces paramètres surchargent ceux de la plateforme pour ce programme',
  'admin.programSettings.form.logo.label': 'Logo principal',
  'admin.programSettings.form.logo.placeholder': 'https://example.com/logo.png',
  'admin.programSettings.form.logoSmall.label': 'Logo compact',
  'admin.programSettings.form.logoSmall.placeholder': 'https://example.com/logo-small.png',
  'admin.programSettings.form.favicon.label': 'Favicon',
  'admin.programSettings.form.favicon.placeholder': 'https://example.com/favicon.ico',
  'admin.programSettings.form.colorPrimary.label': 'Couleur primaire',
  'admin.programSettings.form.colorPrimary.placeholder': '#000000',
  'admin.programSettings.form.colorSecondary.label': 'Couleur secondaire',
  'admin.programSettings.form.colorSecondary.placeholder': '#ffffff',
  'admin.programSettings.form.name.label': 'Nom du Programme',
  'admin.programSettings.form.name.placeholder': 'Nom du Programme',
  'admin.programSettings.form.description.label': 'Description du programme',
  'admin.programSettings.form.description.placeholder': 'Description du programme',
  'admin.programSettings.form.mentorName.label': 'Nom personnalisé du Mentor',
  'admin.programSettings.form.mentorName.placeholder': 'Nom personnalisé du Mentor',
  'admin.programSettings.form.menteeName.label': 'Nom personnalisé du Mentoré',
  'admin.programSettings.form.menteeName.placeholder': 'Nom personnalisé du Mentoré',
  'admin.programSettings.form.dashboardType.label': 'Type de tableau de bord',
  'admin.programSettings.form.dashboardType.matching': 'Suivre les matching',
  'admin.programSettings.form.dashboardType.feedback': 'Suivre les avis',
  'admin.programSettings.form.programPeriod.label': 'Période du programme :',
  'admin.programSettings.form.programPeriod.start.label': 'Début',
  'admin.programSettings.form.programPeriod.start.placeholder': 'Début',
  'admin.programSettings.form.programPeriod.end.label': 'Fin',
  'admin.programSettings.form.programPeriod.end.placeholder': 'Fin',
  'admin.programSettings.form.defaultInactivityDays.label':
    "Délais avant envoi de l'e-mail d'inactivité par rapport au dernier message laissé par l'utilisateur (en jours)",
  'admin.programSettings.form.defaultInactivityDays.placeholder': 'Nombre de jours',
  'admin.programSettings.form.contactWarningEnabled.label':
    'Avertir l’utilisateur en cas de partage de coordonnées personnelles (e-mail, téléphone, réseaux sociaux, etc...)',
  'admin.programSettings.form.maxUserPerGroup.label': 'Nombre maximum de mentor et mentoré par groupe',
  'admin.programSettings.form.maxGroupPerMentor.label': 'Nombre maximum de groupe par mentor',
  'admin.programSettings.form.maxGroupPerMentee.label': 'Nombre maximum de groupe par mentoré',
  'admin.programSettings.form.max.placeholder': 'Nombre maximum',
  'admin.programSettings.form.matchingCriteriaEnabled.label': 'Activer les critères de matching',
  'admin.programSettings.form.matchingAutoSuggestEnabled.label': 'Autoriser le matching automatique',
  'admin.programSettings.form.matchingAdditionalInstructions.label': 'Instructions complémentaires',
  'admin.programSettings.form.matchingAdditionalInstructions.placeholder': 'Instructions complémentaires...',
  'admin.programSettings.form.mentorMatchingCriteria.label': 'Critère de matching mentor',
  'admin.programSettings.form.mentorMatchingCriteria.placeholder': "Exemple: J'aime les maths, musique etc.",
  'admin.programSettings.form.menteeMatchingCriteria.label': 'Critère de matching mentoré',
  'admin.programSettings.form.menteeMatchingCriteria.placeholder': "Exemple: J'aime les maths, musique etc.",
  'admin.programSettings.form.menteeCanBookSession.label': 'Le mentoré peut réserver une session',
  'admin.programSettings.form.shouldReviewSessionRating.label': 'Note de qualité de session',
  'admin.programSettings.form.shouldReviewSessionReview.label': 'Avis de qualité de session',
  'admin.programSettings.form.shouldMentorReviewSessionPresence.label': 'Présence de mentoré',
  'admin.programSettings.form.shouldReviewSessionDeliverable.label': 'Livrable de session',
  'admin.programSettings.form.shouldMentorReviewSessionDeliverableRate.label': 'Note sur 20 de livrable de session',
  'admin.programSettings.form.shouldMentorReviewSessionDeliverableReport.label':
    'Compte rendu de fin de session (mentor)',
  'admin.programSettings.form.mentorReportTemplate.label': 'Template de compte rendu de session',
  'admin.programSettings.form.mentorReportTemplate.placeholder': 'Template de compte rendu...',
  'admin.programSettings.form.shouldMenteeReviewSessionReport.label': 'Compte rendu de fin de session (mentoré)',
  'admin.programSettings.form.menteeReportTemplate.label': 'Template de compte rendu de session (mentoré)',
  'admin.programSettings.form.menteeReportTemplate.placeholder': 'Template de compte rendu...',
  'admin.programSettings.toast.updateSuccess': 'Enregistrement réussi',
  'admin.programSettings.toast.createError': 'Erreur lors de la création du programme',

  // Sessions
  'session.addToCalendarModal.title': `Ajouter à<br/>mon calendrier 📆`,
  'session.addToCalendarModal.bodyInformation': `Soyez sûr de ne pas manquer votre session de mentorat en ajoutant cet événement à votre calendrier de préférence.`,
  'session.listing.empty': `Vous n'avez pas encore de session.`,
  'session.reviewModal.addDeliverableModal.title': `Des documents attendus<br/>par votre %*mentor*% ? 🤔`,
  'session.reviewModal.addDeliverableModal.body': `Ajoutez des documents à cette session pour les partager avec votre %*mentor*%.`,
  'session.reviewModal.addDeliverableModal.sending': `Envoi...`,
  'sesion.reviewModal.addDeliverableModal.received': `Réceptionné`,
  'session.reviewModal.addDeliverableModal.sendLater': `Envoyer plus tard`,
  'session.reviewModal.addDeliverableModal.next': `Suivant`,
  'session.reviewModal.addDeliverableModal.fileDeleted': `Fichier supprimé.`,
  'session.reviewModal.addDeliverableModal.noDeliverableCheckbox': `Je ne souhaite pas envoyer de livrable pour cette session`,
  'session.deliverable.sentAt': `Envoyé le`,
  'session.deliverable.noDeliverable': `Aucun document rendu.`,
  'session.deliverable.downloadInProgress': `Téléchargement en cours...`,
  'session.deliverable.downloading': `Téléchargement...`,
  'session.deliverable.downloadStarted': `Téléchargement démarré`,
  'session.deliverable.downloadMayTakeTime': `Le téléchargement peut prendre du temps selon la taille du fichier...`,
  'session.deliverable.downloadComplete': `Téléchargement terminé !`,
  'session.newSessionModal.title': `Planifier une nouvelle session`,
  'session.newSessionModal.modifySession.title': `Modifier la session ✏️`,
  'session.newSessionModal.generalInformation.input.group.label': `Groupe`,
  'session.newSessionModal.generalInformation.input.name.label': `Nom de la session`,
  'session.newSessionModal.generalInformation.input.name.placeholder': `Entrer un nom pour cette session`,
  'session.newSessionModal.generalInformation.input.date.label': `Date`,
  'session.newSessionModal.generalInformation.input.date.placeholder': `12-03-2024`,
  'session.newSessionModal.generalInformation.input.type.label': `Type de session`,
  'session.newSessionModal.generalInformation.input.location.label': `Lieu`,
  'session.newSessionModal.generalInformation.input.location.placeholder': `Au sein de l'université, dans les locaux de l'entreprise, etc.`,
  'session.newSessionModal.locationDisabledPlaceholder': `Pas de lieu requis pour une session en visio`,
  'session.newSessionModal.endsAt': `Se termine à {time}`,
  'session.newSessionModal.generalInformation.input.schedule.label': `Horaire`,
  'session.newSessionModal.generalInformation.input.schedule.placeholder': `09:00`,
  'session.newSessionModal.generalInformation.input.duration.label': `Durée`,
  'session.newSessionModal.generalInformation.input.objective.label': `Objectif de session`,
  'session.newSessionModal.generalInformation.input.objective.none': `Aucun objectif`,
  'session.newSessionModal.plan': `Planifier la session`,
  'session.newSessionModal.modify': `Confirmer les modifications`,
  'session.newSessionModal.success.create': `Votre session a bien été créée`,
  'session.newSessionModal.success.update': `Votre session a bien été mise à jour`,
  'session.newSessionModal.error.update': `Une erreur est survenue lors de la mise à jour de la session`,
  'session.newSessionModal.error.overlap': `La session chevauche une autre session`,
  'session.newSessionModal.validation.date.required': `La date est requise`,
  'session.newSessionModal.validation.type.required': `Le type est requis`,
  'session.newSessionModal.validation.schedule.required': `L'horaire est requis`,
  'session.newSessionModal.validation.schedule.invalid': `Horaire invalide, par exemple 14:30`,
  'session.newSessionModal.validation.duration.required': `La durée est requise`,
  'session.newSessionModal.validation.group.required': `Le groupe est requis`,
  'session.newSessionModal.validation.location.requiredIfInPerson': `Le lieu est requis si le type est en présentiel`,
  'session.newSessionModal.validation.formIncomplete': `Veuillez compléter tous les champs requis`,
  'session.rateSessionModal.infoMentorNoAccess': `Votre %*mentor*% n'a pas accès à cet avis.`,
  'session.rateSessionModal.infoMenteesNoAccess': `Vos %*mentee*%s n'ont pas accès à cet avis.`,
  'session.rateSessionModal.input.review.label': `Avis`,
  'session.rateSessionModal.input.review.placeholder': `La session s'est super bien passée, etc.`,
  'session.deliverablesRatingModal.title': `Il est temps<br/>de noter vos %*mentee*%s  ! 🎓`,
  'session.deliverablesRatingModal.body': `Notez le travail de vos étudiants si un livrable était attendu lors de cette session.`,
  'session.deliverablesRatingModal.whatNoteDoYouGive': `Quelle note attribuez-vous à {name} ?`,
  'session.deliverablesRatingModal.sentAt': `Envoyé le {date}`,
  'session.deliverablesRatingModal.noMentees': `Aucun %*mentee*% n'était présent lors de cette session.<br />Vous pouvez continuer à la prochaine étape.`,
  'session.deliverablesRatingModal.success': `Vos notes ont été enregistrées avec succès !`,
  'session.deliverablesRatingModal.invalidRate': `Une note doit être comprise entre 0 et 20.`,
  'session.finishedReview.title': `La session a été complétée<br/>avec succès ! 🎉`,
  'session.finishedReview.body.part1': `Un grand merci pour votre implication !`,
  'session.finishedReview.body.part2': `Grâce à vous, cette session de mentorat est un véritable succès. Votre bilan détaillé et vos précieux retours nous permettront grandement d'améliorer l'expérience de ce programme !`,
  'session.finishedReview.success': `Vos retours ont été enregistrés avec succès !`,
  'session.presencesModal.title': `Valider les présences<br/>à la session 📝`,
  'session.presencesModal.body': `Indiquez qui était présent ou absent lors de cette session.`,
  'session.presencesModal.presenceFor': `Présence de {name}`,
  'session.presencesModal.success': `Les présences ont été enregistrées avec succès !`,
  'session.rateSessionModal.title': `Alors, c'était comment ?<br/>dites-nous en plus ! 💪`,
  'session.rateSessionModal.body': `Comment s'est passée la session ?`,
  'session.rateSessionModal.success': `Votre retour a été enregistré avec succès !`,
  'session.reportModal.title': `On finit<br/>par un bilan ! ✨`,
  'session.reportModal.body': `Prenez quelques minutes pour rédiger votre compte-rendu !<br/><br/>C’est l’occasion d’apporter des retours précieux à vos %*mentee*%s : axes d’amélioration, points importants de la session ou évaluation de livrables. Chaque détail compte pour les aider à avancer.`,
  'session.reportModal.input.report.label': `Compte-rendu`,
  'session.reportModal.input.report.placeholder': `Observations, détails des notes, Conclusions...`,
  'session.reportModal.success': `Votre compte-rendu a été enregistré avec succès !`,
  'session.reportModal.modifyReport.report': `Modifier le compte-rendu`,
  'session.deliverables.title': `Notes et rendus %*mentee*%s`,
  'session.deliverables.averageOfGrades': `Moyenne des notes :`,
  'session.deliverables.notGraded': `Non noté`,
  'session.deliverables.noGradeAndDeliverable': `Aucune note ou rendu.`,
  'session.deliverables.noDeliverable': `Aucun rendu.`,
  'session.ownDeliverables.title': `Mes livrables`,
  'session.ownDeliverables.modifyDeliverables': `Modifier mes livrables`,
  'session.deliverables.modifyRating': `Modifier les notes`,
  'session.generalInformations.title': `Informations générales`,
  'session.type.online': `En ligne`,
  'session.type.irl': `En présentiel`,
  'session.participants.title': `Statut de la session par participant`,
  'session.pendingActions.title': `Actions en attente`,
  'session.pendingActions.finishedActions': `Actions<br/>terminées`,
  'session.pendingActions.completeSession': `Compléter la session`,
  'session.pendingActions.review.title': `Laisser un avis`,
  'session.pendingActions.review.label': `Avis`,
  'session.pendingActions.presences.title': `Valider la/les présence(s)`,
  'session.pendingActions.presences.label': `Présence(s)`,
  'session.pendingActions.deliverables.label': `Noter`,
  'session.pendingActions.deliverables.title': `Noter le/les %*mentee*%(s)`,
  'session.pendingActions.sendDeliverable.title': `Envoyer un livrable`,
  'session.pendingActions.sendDeliverable.label': `Livrable(s)`,
  'session.pendingActions.report.title': `Rédiger un compte-rendu`,
  'session.pendingActions.report.label': `Compte-rendu`,
  'session.pendingActions.finished.title': `Session terminée 🎉`,
  'session.pendingActions.finished.label': `Terminée !`,
  'session.presences.title': `Présences`,
  'session.presences.noPresences': `Aucune présence enregistrée.`,
  'session.report.title': `Compte-rendu du %*mentor*%`,
  'session.report.empty': `Aucun compte-rendu n'a été rédigé.`,
  'session.report.modified': `Modifié le`,
  'session.menteeReportModal.title': `Partagez votre<br/>retour d'expérience ! 📝`,
  'session.menteeReportModal.body': `Prenez un moment pour rédiger votre rapport de session.<br/><br/>C'est l'occasion de noter ce que vous avez appris, vos questions restantes, et vos suggestions pour les prochaines sessions.`,
  'session.menteeReportModal.input.report.label': `Votre rapport`,
  'session.menteeReportModal.success': `Votre rapport a été enregistré avec succès !`,
  'session.menteeReportModal.modifyReport': `Modifier le rapport`,
  'session.pendingActions.menteeReport.title': `Rédiger un rapport`,
  'session.pendingActions.menteeReport.label': `Rapport`,
  'session.menteeReport.title': `Rapport du %*mentee*%`,
  'session.menteeReport.author': `Rédigé par`,
  'session.menteeReport.empty': `Aucun rapport n'a été rédigé.`,
  'session.menteeReport.modified': `Modifié le`,
  'session.review.title': `Avis`,
  'session.review.averageOfRates': `Moyenne des notes :`,
  'session.review.noRate': `Aucune note.`,
  'session.review.noReview': `Aucun avis.`,
  'session.cancel.confirmation.title': `Êtes-vous sûr(e) de vouloir annuler cette session ?`,
  'session.cancel.success': `La session a été annulée avec succès !`,
  'session.decline.success': `La session a été déclinée avec succès !`,
  'session.accept.success': `La session a été acceptée avec succès !`,
  'session.addToCalendar.session.title': `Ajouter à mon calendrier`,
  'session.addToCalendar.event.title': `Session de mentorat`,
  'session.status.all': 'Toutes',
  'session.status.planned': 'Planifiée',
  'session.status.waitConfirmation': 'À confirmer',
  'session.status.waitReviews': 'À compléter',
  'session.status.ongoing': 'À compléter par mentor/é',
  'session.status.none': 'Aucun statut',
  'session.status.finished': 'Terminée',
  'session.status.cancelled': 'Annulée',
  'session.status.admin.all': 'Toutes',
  'session.status.admin.planned': 'Planifiée',
  'session.status.admin.ongoing': 'À compléter par mentor/é',
  'session.status.admin.finished': 'Terminée',
  'session.status.admin.cancelled': 'Annulée',
  'session.status.user.present': 'Présent(e)',
  'session.status.user.absent': 'Absent(e)',
  'session.status.user.waitConfirmation': `À confirmer`,
  'session.status.user.waitReviews': `Non completée`,
  'session.status.user.planned': `Participe`,
  'session.status.user.finished': `Completée`,
  'session.status.user.cancelled': 'Absent(e)',
  'session.status.grade.rated': 'Noté(e)',
  'session.status.grade.toFill': 'À remplir',

  // Chat
  'chat.conversationsList.empty': `Vous n'avez pas encore de conversation.`,
  'chat.conversationsList.select': 'Commencez par sélectionner une conversation.',
  'chat.conversationsList.unread': 'Nouveaux messages',
  'chat.conversationsList.searchPlaceholder': `Rechercher une conversation`,
  'chat.conversationsList.filterLabel': `Filtrer les conversations`,
  'chat.conversationsList.filter.all': `Tous`,
  'chat.conversationsList.filter.unread': `Non lus`,
  'chat.conversationsList.noResult': `Aucune conversation ne correspond.`,
  'chat.conversationsList.you': `Vous :`,
  'chat.conversationsList.unreadCount': `{count} message(s) non lu(s)`,
  'chat.conversationsList.sessionRequest': `Demande de session`,
  'chat.conversationsList.attachment': `Pièce jointe`,
  'chat.conversationsList.yesterday': `hier`,
  'chat.conversation.noMessagesSentYetInGroup': `Vous n'avez pas encore échangé avec votre groupe de mentorat. Envoyez un premier message pour vous présenter.`,
  'chat.conversation.generatingAIMessage': 'Génération de votre message...',
  'chat.conversation.placeholder.message': `Écrivez un message...`,
  'chat.conversation.attachFile': `Joindre un fichier`,
  'chat.conversation.removeFile': `Retirer {name}`,
  'chat.conversation.today': `Aujourd'hui`,
  'chat.conversation.yesterday': `Hier`,
  'chat.empty.title': `Lancez la conversation`,
  'chat.empty.introduce': `Me présenter`,
  'chat.privacyNotice.text': `Échangez dans le respect de la charte du programme et évitez de partager des informations personnelles sensibles.`,
  'chat.privacyNotice.dismiss': `Masquer ce rappel`,
  'chat.programmeEnded.text': `Ce programme est terminé depuis le {date}. Vous pouvez toujours échanger ici.`,
  'chat.header.yourRole': `Votre rôle :`,
  'chat.header.sessionsProgress': `Session {done} sur {expected}`,
  'chat.header.sessionsCount': `{count} session(s) tenue(s)`,
  'chat.context.label': `Contexte du binôme`,
  'chat.context.open': `Voir le contexte du binôme`,
  'chat.messageSearch.open': `Rechercher dans la conversation`,
  'chat.messageSearch.placeholder': `Rechercher un message`,
  'chat.messageSearch.count': `{current} sur {total}`,
  'chat.messageSearch.noResult': `Aucun résultat`,
  'chat.messageSearch.older': `Résultat précédent`,
  'chat.messageSearch.newer': `Résultat suivant`,
  'chat.messageSearch.close': `Fermer la recherche`,
  'chat.attachments.label': `Fichiers joints`,
  'chat.attachments.countOne': `1 fichier joint`,
  'chat.attachments.countOther': `{count} fichiers joints`,
  'chat.attachments.uploading': `{count} en cours`,
  'chat.attachments.failed': `{count} en échec`,
  'chat.attachments.ready': `Prêt`,
  'chat.attachments.failedFile': `Échec de l'envoi`,
  'chat.attachments.retry': `Réessayer l’envoi de {name}`,
  'chat.attachments.uploadingFile': `Envoi de {name}`,
  'chat.attachments.show': `Afficher les fichiers joints`,
  'chat.attachments.hide': `Masquer les fichiers joints`,
  'chat.context.nextSession': `Prochaine session`,
  'chat.context.noSession': `Aucune session planifiée pour le moment.`,
  'chat.context.progress': `Parcours`,
  'chat.context.sessionsDone': `Sessions tenues : {done} sur {expected}`,
  'chat.context.objectives': `Objectifs du binôme`,
  'chat.context.objective.done': `atteint`,
  'chat.context.objective.current': `en cours`,
  'chat.context.objective.todo': `à venir`,
  'chat.context.documents': `Documents échangés`,
  'chat.context.documentsAll': `Voir les {count} documents`,
  'chat.context.moreImages': `Voir les {count} images`,
  'chat.documents.searchPlaceholder': `Rechercher un document`,
  'chat.documents.filterLabel': `Type de document`,
  'chat.documents.filter.all': `Tout`,
  'chat.documents.filter.images': `Images`,
  'chat.documents.filter.files': `Fichiers`,
  'chat.documents.open': `Ouvrir {name}`,
  'chat.documents.download': `Télécharger {name}`,
  'chat.conversationsList.title': `Messages`,
  'chat.conversationsList.noMessageYet': `Pas encore de message`,
  'chat.newConversation.open': `Nouvelle conversation`,
  'chat.newConversation.title': `Nouvelle conversation`,
  'chat.newConversation.description': `Choisissez une personne de vos groupes pour lui écrire.`,
  'chat.newConversation.searchPlaceholder': `Rechercher une personne`,
  'chat.newConversation.heading': `Personnes de vos groupes`,
  'chat.newConversation.empty': `Aucune personne trouvée.`,
  'chat.session.loading': `Chargement de la session`,
  'chat.session.today': `Aujourd’hui, {time}`,
  'chat.session.metaOnline': `{duration} · en visioconférence`,
  'chat.session.metaPlace': `{duration} · {place}`,
  'chat.session.duration.minutes': `{count} min`,
  'chat.session.duration.hours': `{hours} h`,
  'chat.session.duration.hoursMinutes': `{hours} h {minutes}`,
  'chat.session.status.toConfirm': `À confirmer`,
  'chat.session.status.planned': `Planifiée`,
  'chat.session.status.ongoing': `En cours`,
  'chat.session.status.toComplete': `À compléter`,
  'chat.session.status.waitReviews': `Retours en cours`,
  'chat.session.status.finished': `Terminée`,
  'chat.session.status.cancelled': `Annulée`,
  'chat.session.waitingFor': `En attente de {names}`,
  'chat.session.startsIn': `Commence dans {count} min`,
  'chat.session.startsInHours': `Commence dans {count} h`,
  'chat.session.endsAt': `Se termine à {time}`,
  'chat.session.reportExpected': `Compte rendu attendu de votre part`,
  'chat.session.cancelledOn': `Annulée le {date}`,
  'chat.session.edit': `Modifier la proposition`,
  'chat.session.join': `Rejoindre la session`,
  'chat.session.addToCalendar': `Ajouter à mon agenda`,
  'chat.session.writeReport': `Rédiger le compte rendu`,
  'chat.session.viewReport': `Voir le compte rendu`,
  'chat.files.open': `Ouvrir {name}`,
  'chat.files.download': `Télécharger {name}`,
  'chat.documents.noResult': `Aucun document ne correspond à « {query} »`,
  'chat.documents.noResultHint': `La recherche porte sur le nom des fichiers et le nom de la personne qui les a partagés.`,
  'chat.documents.clearSearch': `Effacer la recherche`,
  'chat.documents.none': `Aucun document de ce type.`,
  'chat.conversation.error.messageTooLong': `Votre message dépasse la limite de 5000 caractères.`,
  'chat.conversation.noUsersFound': `Aucun utilisateur trouvé.`,
  'chat.conversation.error.fileTooLarge': `Le fichier est trop volumineux. Taille maximale : {maxSize}`,
  'chat.conversation.session.request': `Une session a été demandée.`,
  'chat.conversation.session.declined': `Vous avez décliné la session.`,
  'chat.conversation.session.accepted': `Vous avez accepté la session.`,
  'chat.conversation.session.addToCalendar': `Ajouter à mon calendrier`,
  'chat.conversation.session.place': `Lieu`,
  'chat.conversation.session.objective': `Objectif {number}`,
  'chat.conversation.seenBy': `Vu par`,
  'chat.conversation.uploading': `Envoi en cours`,
  'chat.conversation.uploaded': `Envoyé`,
  'chat.conversation.fileDeleted': `Fichier supprimé`,
  'chat.contactWarningModal.title': `⚠️ Échange de coordonnées détecté`,
  'chat.contactWarningModal.body.intro': `Pour garantir une expérience optimale, nous vous recommandons de continuer à échanger directement via le chat de la plateforme.`,
  'chat.contactWarningModal.body.benefit1': `✔️ Vous bénéficiez d’un <b>historique centralisé</b>, accessible à tout moment`,
  'chat.contactWarningModal.body.benefit2': `✔️ Vos <b>échanges sont protégés</b> contre les malentendus ou les abus`,
  'chat.contactWarningModal.body.warning': `Échanger des coordonnées en dehors du chat peut entraîner une perte de protection et d’informations importantes.`,
  'chat.contactWarningModal.button.send': `Envoyer quand même`,
  'chat.contactWarningModal.button.cancel': `Annuler`,

  // meeting
  'meeting.actions.left': 'Vous avez quitté la session.',

  // Users
  'user.profile.title': `Paramètres`,
  'user.profile.subtitle': `Gérez les paramètres de votre compte et vos préférences.`,
  'user.profile.nav.profile': `Profil`,
  'user.profile.nav.programs': `Programmes`,
  'user.profile.programs.title': `Mes programmes`,
  'user.profile.programs.subtitle': `Gérez les paramètres de chaque programme auquel vous participez.`,
  'user.profile.programs.show': `Voir`,
  'user.profile.programs.showCriteria': `Voir les critères`,
  'user.profile.programs.hideCriteria': `Masquer`,
  'user.profile.nav.password': `Authentification`,
  'user.profile.name': `Nom`,
  'user.profile.bio': `Bio`,
  'user.profile.uploadImage': `Changer la photo`,
  'user.profile.description': `Description :`,
  'user.profile.description.empty': `Aucune description n'a été renseignée.`,
  'user.profile.sharedNotes.title': `Notes internes sur l'utilisateur`,
  'user.profile.sharedNotes': `Ce champ est visible uniquement par les administrateurs et managers.`,
  'user.profile.sharedNotes.add.placeholder': `[JJ/MM/AA] Prénom : Saisissez votre note ici...`,
  'user.profile.sharedNotes.saveChanges': `Enregistrer les modifications`,
  'user.profile.sharedNotes.success': `Les notes ont été enregistrées avec succès !`,
  'user.profile.edit': `Modifier mon profil`,
  'user.profile.sendMessage': `Envoyer un message`,
  'user.profile.preferences': `Préférences`,
  'user.profile.credentials': `Identifiants`,
  'user.profile.language.appLanguage': `Langue de l'application`,
  'user.profile.matchingCriteria': `Critère de matching :`,
  'user.profile.mentorMatchingCriteria': `Critères de matching (%*mentor*%) :`,
  'user.profile.menteeMatchingCriteria': `Critères de matching (%*mentee*%) :`,
  'user.profile.matchingCriterias.title': `Critères de mise en relation`,
  'user.profile.matchingCriterias.criteriaLabel': `Critères {role}`,
  'user.profile.matchingCriterias.mentorSection': `%*mentor*%`,
  'user.profile.matchingCriterias.menteeSection': `%*mentee*%`,
  'user.profile.matchingCriterias.empty': `Non renseigné`,
  'user.info.copyEmail': `Copier l'adresse e-mail`,
  'user.info.copyEmail.success': `Adresse copiée !`,

  // Dashboard
  'dashboard.greeting': `Bonjour {name}`,
  'dashboard.subtitle': `Retrouvez votre progression et vos prochaines étapes.`,
  'dashboard.shared.programProgress.title': `Avancée(s) du programme`,
  'dashboard.shared.programProgress.viewProgram': `Voir l'objectif de programme`,
  'dashboard.shared.programProgress.viewProgramModal': `Objectif du programme`,
  'dashboard.shared.programProgress.programBadge': `Programme`,
  'dashboard.shared.programProgress.doneSessions': `Session(s) terminée(s)`,
  'dashboard.shared.programProgress.pendingActions': `Action(s) en attente`,
  'dashboard.shared.programProgress.members': `Membres du groupe`,
  'dashboard.shared.programProgress.mentor': `Mentor`,
  'dashboard.shared.programProgress.mentee': `Mentoré`,
  'dashboard.shared.programProgress.me': `Moi`,
  'dashboard.shared.programProgress.groupSettings': `Paramètres du groupe`,
  'dashboard.shared.programObjectives.title': `Sessions du programme`,
  'dashboard.shared.programObjectives.noObjectives': `Aucune session définie pour ce programme.`,
  'dashboard.shared.programObjectives.noGroups': `Vous n'avez pas encore de groupe dans ce programme.`,
  'dashboard.shared.programObjectives.objectiveNumber': `Objectif {number}`,
  'dashboard.shared.programObjectives.progress': `{completed} session(s) planifiée(s) sur {expected}`,
  'dashboard.shared.programObjectives.readBeforeSession': `À lire avant de commencer la session`,
  'dashboard.shared.programObjectives.planSession': `Ajouter une session`,
  'dashboard.shared.programObjectives.chatWithGroup': `Échanger avec mon groupe`,
  'dashboard.shared.programObjectives.createNewSession': `Créer une nouvelle session`,
  'dashboard.shared.programObjectives.linkExistingSession': `Lier une session existante`,
  'dashboard.shared.programObjectives.notPlanned': `Non planifié`,
  'dashboard.shared.programObjectives.learnMore': `En savoir plus`,
  'dashboard.shared.programObjectives.cardTitle': `Parcours {name}`,
  'dashboard.shared.programObjectives.viewMore': `Voir plus`,
  'dashboard.shared.programObjectives.exchange': `Échanger`,
  'dashboard.shared.programObjectives.schedule': `Planifier`,
  'dashboard.shared.programObjectives.sessionLabel': `{name}, le {date}`,
  'dashboard.shared.lockedContent.noGroup': `Cette section sera débloquée lorsque vous aurez un groupe de mentorat`,
  'dashboard.shared.waitingAlert.title': `Votre matching est en cours`,
  'dashboard.shared.waitingAlert.description': `Vous recevrez un e-mail dès que vous serez matché(e). En attendant, pensez à compléter votre profil si ce n'est pas déjà fait.`,

  // Profile completion
  'profileCompletion.title': `Profil complété à`,
  'profileCompletion.profileLevel': `Niveau du profil : {level}`,
  'profileCompletion.levels.beginner': `Débutant`,
  'profileCompletion.levels.basic': `Basique`,
  'profileCompletion.levels.intermediate': `Intermédiaire`,
  'profileCompletion.levels.advanced': `Avancé`,
  'profileCompletion.levels.expert': `Expert`,
  'profileCompletion.description': `Encore un petit effort pour optimiser vos opportunités de mentorat.`,
  'profileCompletion.nextStep': `Prochaine étape`,
  'profileCompletion.steps.mentorCriteria': `Renseigner vos critères de mise en relation pour ce programme`,
  'profileCompletion.steps.menteeCriteria': `Renseigner vos critères de mise en relation pour ce programme`,
  'profileCompletion.steps.findMentor': `Trouver un mentor`,
  'profileCompletion.steps.description': `Compléter votre description de profil`,
  'profileCompletion.steps.picture': `Ajouter une photo de profil`,
  'profileCompletion.buttons.fillCriteria': `Renseigner`,
  'profileCompletion.buttons.findMentor': `Trouver`,
  'profileCompletion.buttons.addDescription': `Compléter`,
  'profileCompletion.buttons.addPicture': `Ajouter`,
  'profileCompletion.steps.phone': `Ajouter votre numéro de téléphone`,
  'profileCompletion.buttons.addPhone': `Ajouter`,

  // Session objectives link modal
  'sessionObjectives.linkSessionModal.title': `Lier une session à l'objectif`,
  'sessionObjectives.linkSessionModal.loading': `Chargement des sessions...`,
  'sessionObjectives.linkSessionModal.error': `Erreur lors du chargement des sessions`,
  'sessionObjectives.linkSessionModal.noSessions': `Aucune session disponible dans ce groupe`,
  'sessionObjectives.linkSessionModal.selectLabel': `Sélectionner une session`,
  'sessionObjectives.linkSessionModal.linkButton': `Lier la session`,
  'sessionObjectives.linkSessionModal.cancelButton': `Annuler`,
  'sessionObjectives.linkSessionModal.success': `Session liée avec succès à l'objectif`,
  'dashboard.shared.plannedSessions.title': `Session(s) planifiée(s)`,
  'dashboard.shared.plannedSessions.noSession': `Aucune session planifiée.`,
  'dashboard.mentor.mentees.title': `Vos %*mentee*%s`,
  'dashboard.mentor.mentees.noMentee': `Vous n'avez pas encore de %*mentee*%(s) pour ce programme.`,
  'dashboard.shared.groups.title': `Vos groupes`,
  'dashboard.shared.groups.noGroup': `Vous n'avez pas encore de groupe.`,
  'dashboard.shared.groups.as': `En tant que`,
  'dashboard.shared.groups.searchPlaceholder': `Rechercher un groupe...`,
  'dashboard.shared.groups.noGroupFound': `Aucun groupe trouvé.`,

  // redirect
  'redirect.loading': `Redirection en cours...`,
  'redirect.notification.interface': `Changement de droits sur votre nouveau programme, redirection...`,

  // auth
  'auth.login.title': `Connexion à votre espace <strong>{appTitle}</strong>`,
  'auth.login.classicLogin': `Connexion avec e-mail et mot de passe`,
  'auth.login.login': `Se connecter`,
  'auth.login.error': 'Identifiant ou mot de passe incorrect',
  'auth.login.email.errors.invalid': "L'e-mail est invalide",
  'auth.login.email.placeholder': `Saisissez votre e-mail`,
  'auth.login.password.errors.invalid': 'Le mot de passe est invalide',
  'auth.login.checkingSSOUser': `Vérification de votre compte...`,
  'auth.login.forgotPassword': `Mot de passe oublié ou première connexion ?`,
  'auth.login.or': 'Ou continuer avec',
  'auth.login.continueWith': 'Continuer avec {companyName}',
  'auth.login.continue': `Continuer`,
  'auth.login.changeEmail': `Changer`,
  'auth.login.changeEmailAriaLabel': `Changer d'adresse e-mail`,
  'auth.login.signedInAs': `Connexion en tant que`,
  'auth.login.unknownEmail.title': `Aucun compte à cette adresse`,
  'auth.login.unknownEmail.body': `Vérifiez l'adresse saisie. Vous avez peut-être un compte sous une autre adresse, personnelle ou professionnelle. Si vous ne la retrouvez pas, contactez le support.`,
  'auth.forgotPassword.title': `Mot de passe oublié ?`,
  'auth.forgotPassword.body': `Un code sera envoyé à votre adresse e-mail pour réinitialiser votre mot de passe`,
  'auth.forgotPassword.backToLogin': `Retour à la connexion`,
  'auth.forgotPassword.contactSupport.text': `Vous n'avez pas reçu l'e-mail ? Contactez-nous à`,
  'auth.forgotPassword.sendEmail': `Récupérer mon mot de passe`,
  'auth.forgotPassword.error.userNotFound': `L'e-mail n'est pas enregistré dans notre base de données. Veuillez vérifier votre e-mail.`,
  'auth.forgotPassword.error.rateLimitExceeded': `Trop de demandes de réinitialisation. Veuillez réessayer dans 1 heure.`,
  'auth.forgotPassword.error.tokenExpired': `Ce lien de réinitialisation a expiré (30 minutes). Veuillez faire une nouvelle demande.`,
  'auth.forgotPassword.error.tokenAlreadyUsed': `Ce lien de réinitialisation a déjà été utilisé. Veuillez faire une nouvelle demande si nécessaire.`,
  'auth.forgotPassword.error.tokenInvalid': `Ce lien de réinitialisation est invalide. Veuillez faire une nouvelle demande.`,
  'auth.forgotPassword.emailSent': `Si cette adresse est enregistrée, vous recevrez un e-mail avec les <strong>instructions pour réinitialiser votre mot de passe</strong>.`,
  'auth.forgotPassword.emailSentSuccess': `Si cette adresse est enregistrée, vous recevrez un e-mail avec les instructions pour réinitialiser votre mot de passe.`,
  'auth.forgotPassword.checkEmail.title': `Vérifiez votre e-mail !`,
  'auth.forgotPassword.checkEmail.body': `Si <strong>{email}</strong> est enregistrée, nous y avons envoyé un lien de réinitialisation, valable <strong>30 minutes</strong>.`,
  'auth.forgotPassword.checkEmail.intro': `Pour continuer, cliquez sur le lien envoyé à`,
  'auth.forgotPassword.checkEmail.resend': `Renvoyer l'e-mail`,
  'auth.forgotPassword.resetPassword': `Réinitialiser mon mot de passe`,
  'auth.forgotPassword.success.passwordReset': `Votre mot de passe a été réinitialisé avec succès !`,
  'auth.forgotPassword.success.passwordResetAndLoggedIn': `Votre mot de passe a été réinitialisé avec succès ! Vous êtes maintenant connecté.`,
  'auth.forgotPassword.error.generic': `Une erreur est survenue lors de la réinitialisation du mot de passe.`,
  'auth.saml.error.internalError': `Une erreur s'est produite lors de l'authentification. Contactez le support pour obtenir de l'aide. Code d'erreur : {errorId}`,
  'auth.saml.error.authFailed': `Une erreur s'est produite lors de l'authentification. Contactez le support pour obtenir de l'aide. Code d'erreur : {errorId}`,
  'auth.saml.error.signatureError': `Erreur de validation de signature SAML. Veuillez vérifier la configuration du certificat ou contactez le support. Code : {errorId}`,
  'auth.saml.error.userNotRegistered': `Vous n'avez pas encore accès à la plateforme. Veuillez contacter le support pour obtenir un accès.`,
  'auth.password.errors.required': `Le mot de passe est requis`,
  'auth.password.errors.minLength': `Le mot de passe doit contenir au moins 8 caractères`,
  'auth.password.errors.lowercase': `Le mot de passe doit contenir au moins une lettre minuscule`,
  'auth.password.errors.uppercase': `Le mot de passe doit contenir au moins une lettre majuscule`,
  'auth.password.errors.number': `Le mot de passe doit contenir au moins un chiffre`,
  'auth.password.errors.specialChar': `Le mot de passe doit contenir au moins un caractère spécial ({'@'}$!%*?&-_#)`,
  'auth.password.errors.mismatch': `Les mots de passe ne correspondent pas`,
  'auth.password.modify.title': `Modifier mon mot de passe 🔒`,
  'auth.forgotPassword.error.passwordsDoNotMatch': `Les mots de passe ne correspondent pas.`,
  'invitation.title': `Activez votre compte`,
  'invitation.subtitle': `Définissez votre mot de passe pour activer votre compte sur {company}`,
  'invitation.loading': `Vérification du lien d'invitation…`,
  'invitation.email.label': `Adresse e-mail`,
  'invitation.password.label': `Mot de passe`,
  'invitation.confirmPassword.label': `Confirmer le mot de passe`,
  'invitation.cgu.label': `J'accepte les {cgu} et la {privacy}.`,
  'invitation.cgu.cguLink': `conditions générales d'utilisation`,
  'invitation.cgu.privacyLink': `politique de confidentialité`,
  'invitation.cgu.errors.required': `Vous devez accepter les conditions générales et la politique de confidentialité.`,
  'invitation.submit': `Activer mon compte`,
  'invitation.success': `Votre compte a été activé. Connectez-vous.`,
  'invitation.errorBackToLogin': `Retour à la connexion`,
  'invitation.error.invalid': `Ce lien d'invitation est invalide.`,
  'invitation.error.expired': `Ce lien d'invitation a expiré. Demandez à un administrateur de vous renvoyer une invitation.`,
  'invitation.error.used': `Ce lien d'invitation a déjà été utilisé.`,
  'invitation.error.passwordsDoNotMatch': `Les mots de passe ne correspondent pas.`,
  'invitation.error.generic': `Une erreur est survenue lors de l'activation du compte.`,
  'auth.password.modify.currentPassword': `Mot de passe actuel`,
  'auth.password.modify.newPassword': `Nouveau mot de passe`,
  'auth.password.modify.confirmNewPassword': `Confirmer le nouveau mot de passe`,
  'auth.password.modify.success': `Votre mot de passe a bien été modifié`,
  'user.profile.auth.signInMethods': `Méthodes de connexion`,
  'user.profile.auth.password.configured': `Configuré`,
  'user.profile.auth.password.change': `Changer le mot de passe`,
  'user.profile.auth.password.hide': `Masquer`,
  'user.profile.auth.password.update': `Mettre à jour le mot de passe`,
  'user.profile.auth.twoFactor': `Authentification à deux facteurs`,
  'user.profile.auth.sso.description': `Se connecter avec votre compte {companyName}`,
  'user.profile.auth.authenticatorApp': `Application d'authentification`,
  'user.profile.auth.twoFactor.description': `L'authentification à deux facteurs ajoute une couche de sécurité supplémentaire à votre compte en exigeant plus qu'un simple mot de passe pour se connecter.`,
  'auth.mfa.title': `Authentification à deux facteurs (MFA)`,
  'auth.mfa.description': `Sécurisez votre compte avec une authentification à deux facteurs`,
  'auth.mfa.status.enabled': `Activée`,
  'auth.mfa.status.disabled': `Désactivée`,
  'auth.mfa.button.enable': `Activer`,
  'auth.mfa.button.disable': `Désactiver`,
  'auth.mfa.setup.title': `Configurer l'authentification à deux facteurs 🔐`,
  'auth.mfa.setup.step1.title': `1. Scannez le QR code`,
  'auth.mfa.setup.step1.description': `Utilisez une application d'authentification (Google Authenticator, Authy, Microsoft Authenticator) pour scanner ce QR code`,
  'auth.mfa.setup.step1.manualEntry': `Ou entrez cette clé manuellement :`,
  'auth.mfa.setup.step2.title': `2. Codes de secours`,
  'auth.mfa.setup.step2.description': `Conservez ces codes de secours dans un endroit sûr. Ils vous permettront de vous connecter si vous perdez l'accès à votre application d'authentification.`,
  'auth.mfa.setup.step3.title': `3. Vérifiez le code`,
  'auth.mfa.setup.step3.description': `Entrez le code à 6 chiffres généré par votre application`,
  'auth.mfa.setup.input.code.label': `Code de vérification`,
  'auth.mfa.setup.input.code.placeholder': `123456`,
  'auth.mfa.setup.success': `L'authentification à deux facteurs a été activée avec succès !`,
  'auth.mfa.setup.error': `Le code de vérification est incorrect`,
  'auth.mfa.disable.title': `Désactiver l'authentification à deux facteurs ⚠️`,
  'auth.mfa.disable.description': `Pour désactiver l'authentification à deux facteurs, veuillez entrer votre mot de passe actuel et un code de vérification`,
  'auth.mfa.disable.input.password.label': `Mot de passe actuel`,
  'auth.mfa.disable.input.password.placeholder': `********`,
  'auth.mfa.disable.input.code.label': `Code de vérification`,
  'auth.mfa.disable.input.code.placeholder': `123456`,
  'auth.mfa.disable.success': `L'authentification à deux facteurs a été désactivée`,
  'auth.mfa.disable.error': `Le mot de passe ou le code de vérification est incorrect`,
  'auth.mfa.login.title': `Authentification à deux facteurs 🔐`,
  'auth.mfa.login.description': `Entrez le code à 6 chiffres généré par votre application d'authentification`,
  'auth.mfa.login.input.code.label': `Code de vérification`,
  'auth.mfa.login.input.code.placeholder': `123456`,
  'auth.mfa.login.error': `Code de vérification incorrect`,
  'auth.mfa.login.error.tooManyAttempts': `Trop de tentatives échouées. Veuillez réessayer dans 5 minutes.`,
  'auth.mfa.login.retryIn': `Réessayez dans {time}`,
  'auth.loadingGuard.login': `Connexion...`,
  'auth.loadingGuard.help.title': `Un problème pour vous connecter ?`,
  'auth.loadingGuard.help.body': `Contactez-nous`,
  'auth.editProfile.picture.title': `Un profil avec une photo,<br/>c'est toujours plus chaleureux ! 😊`,
  'auth.editProfile.picture.uploaded': `vous êtes parfait(e) !`,
  'auth.editProfile.picture.conversionError': `Cette photo HEIC n'a pas pu être convertie. Essayez une autre photo, ou un fichier .jpg ou .png.`,
  'auth.editProfile.picture.examples.title': 'Exemples de bonnes photos',
  'auth.editProfile.picture.examples.body': `Une photo professionnelle est nécessaire pour apparaître sur la plateforme. Dans le cas contraire, votre profil pourrait être refusé.`,
  'auth.editProfile.success': `Votre profil a été mis à jour avec succès !`,
  'auth.editProfile.description.title': `Présentez-vous en quelques mots 📝`,
  'auth.editProfile.description.placeholder': `Je suis un(e) ...`,
  'auth.profile.phone': `Téléphone`,
  'auth.profile.phone.empty': `Aucun numéro de téléphone renseigné.`,
  'auth.profile.password': `Mot de passe`,
  'auth.phoneModal.title': `Soyez informé pour <br/> les événements importants  ! 🤙`,
  'auth.phoneModal.body': `Renseignez votre numéro de téléphone pour être notifié(e) des événements importants de votre programme de mentorat.`,
  'auth.phoneModal.input.label': `Numéro de téléphone`,
  'auth.phoneModal.input.placeholder': `+33612345678`,
  'auth.phoneModal.doNotAskAgain': `Ne plus me demander`,
  'auth.phoneModal.success': `Votre numéro de téléphone a été enregistré avec succès !`,
  'auth.language.success': `Votre langue a été mise à jour avec succès !`,
  'auth.phoneModal.error.invalid': 'Le numéro de téléphone est invalide',
  'auth.phoneModal.error.startsWith': 'Le numéro de téléphone doit commencer par + (+33 pour la France)',
  'auth.nameModal.title': `Il nous manque votre nom ! 🫢`,
  'auth.nameModal.body': `Renseignez votre prénom et nom pour que les autres membres de votre groupe de mentorat vous reconnaissent.`,
  'auth.nameModal.success': `Votre nom a été enregistré avec succès !`,
  // General terms
  'user.profile.nav.privacy': `Confidentialité`,
  'user.profile.privacy.title': `Confidentialité et documents légaux`,
  'user.profile.privacy.subtitle': `Consultez les documents qui encadrent l'utilisation de la plateforme et le traitement de vos données.`,
  'user.profile.privacy.cgu': `Conditions générales d'utilisation`,
  'user.profile.privacy.privacyPolicy': `Politique de confidentialité`,
  'user.profile.privacy.version': `Version du {date}`,
  'user.profile.privacy.view': `Consulter`,
  'user.profile.privacy.acceptedAt': `Vous les avez acceptées le {date}`,
  'terms.modal.title': `Conditions d'utilisation et confidentialité`,
  'terms.modal.bodyInformation': `Pour utiliser la plateforme, veuillez accepter nos conditions générales d'utilisation et notre politique de confidentialité.`,
  'terms.modal.accept': `J'accepte`,
  'terms.modal.updated': `Nos conditions générales d'utilisation et notre politique de confidentialité ont été mises à jour. Merci de les accepter à nouveau pour continuer.`,
  'terms.modal.success': `Vous avez accepté les conditions générales et la politique de confidentialité`,

  // UI Button
  'ui.button.back': 'Retour',
  'ui.button.next': 'Suivant',
  'ui.button.close': 'Fermer',
  'ui.button.cancel': 'Annuler',
  'ui.button.confirm': 'Confirmer',
  'ui.button.save': 'Enregistrer',
  'ui.button.delete': 'Supprimer',
  'ui.button.create': 'Créer',
  'ui.button.send': 'Envoyer',
  'ui.button.accept': 'Accepter',
  'ui.button.decline': 'Décliner',
  'ui.button.change': 'Changer',
  'ui.button.continue': 'Continuer',
  'ui.button.fillLater': 'Remplir plus tard',
  'ui.button.support': `Contacter le support`,
  'ui.button.download': `Télécharger`,
  'ui.button.finish': `Terminer`,
  'ui.button.show': `Afficher`,
  'ui.button.filters': `Filtres`,
  'ui.button.export': `Exporter`,
  'ui.button.edit': 'Modifier',
  'ui.button.join': 'Rejoindre',

  // UI Layout
  'ui.layout.nav.dashboard': 'Tableau de bord',
  'ui.layout.nav.groups': 'Groupes',
  'ui.layout.nav.users': 'Utilisateurs',
  'ui.layout.nav.sessions': 'Sessions',
  'ui.layout.nav.settings': 'Paramètres',
  'ui.layout.nav.messages': 'Messages',
  'ui.layout.nav.newSession': 'Planifier une session',
  'ui.layout.nav.support': 'Support',
  'ui.layout.nav.resources': 'Ressources',
  'ui.layout.nav.allGroups': 'Tous les groupes',
  'ui.layout.nav.ariaLabel': 'Navigation principale',
  'ui.layout.skipToContent': 'Aller au contenu principal',

  // Titres de page (WCAG 2.4.2) — composés en « Sujet – Organisation »
  'ui.pageTitle.login': 'Connexion',
  'ui.pageTitle.forgotPassword': 'Mot de passe oublié',
  'ui.pageTitle.invitation': 'Invitation',
  'ui.pageTitle.cgu': `Conditions générales d'utilisation`,
  'ui.pageTitle.privacy': 'Politique de confidentialité',
  'ui.pageTitle.dashboard': 'Tableau de bord',
  'ui.pageTitle.sessions': 'Sessions',
  'ui.pageTitle.chat': 'Messages',
  'ui.pageTitle.profile': 'Profil',
  'ui.pageTitle.adminDashboard': 'Tableau de bord administrateur',
  'ui.pageTitle.adminUsers': 'Utilisateurs',
  'ui.pageTitle.adminGroups': 'Groupes',
  'ui.pageTitle.adminSessions': 'Sessions du programme',
  'ui.pageTitle.adminReminders': 'Relances',
  'ui.pageTitle.adminProgramSettings': 'Paramètres du programme',
  'ui.pageTitle.adminNewProgram': 'Nouveau programme',
  'ui.pageTitle.adminSettings': 'Ma plateforme',
  'ui.pageTitle.downloadDeliverable': 'Téléchargement du livrable',
  'ui.pagination.page': 'Page',
  'ui.pagination.resultsOfOn': 'Résultats {start} à {end} sur {total}',
  'ui.pagination.totalPages': 'Total de pages : {total}',
  'ui.filter.status': 'Statut',
  'ui.filter.group': 'Groupe',
  'ui.filter.hasGroup': 'Avec ou sans groupe',
  'ui.filter.menteesCount': 'Nombre de mentorés',

  // UI Message
  'ui.message.loading': 'Chargement...',

  // UI Select
  'ui.select.defaultOption': 'Sélectionner une option',
  'ui.select.lang.fr': 'Français',
  'ui.select.lang.en': 'Anglais',
  'ui.select.noResults': 'Aucun résultat trouvé',
  'ui.select.selectAll': 'Tout sélectionner',

  // UI Input
  'ui.input.label.optional': 'optionnel',
  'ui.input.placeholder.searchPerson': 'Rechercher par e-mail ou nom, prénom',
  'ui.input.file.instructions.maxSize': 'Taille de fichier max :',
  'ui.input.file.instructions.format': 'Formats acceptés :',
  'ui.input.file.instructions.minSize': 'Taille minimum :',
  'ui.input.file.upload.dragAndDrop': `Glissez et déposez un fichier ou cliquez ici | Glissez et déposez des fichiers ou cliquez ici`,
  'ui.input.email.label': 'E-mail',
  'ui.input.email.placeholder': `john.smith{'@'}example.com`,
  'ui.input.role.label': 'Rôle(s)',
  'ui.input.firstName.label': 'Prénom',
  'ui.input.firstName.placeholder': 'John',
  'ui.input.lastName.label': 'Nom',
  'ui.input.lastName.placeholder': 'Smith',
  'ui.input.password.label': 'Mot de passe',
  'ui.input.password.placeholder': '••••••••',
  'ui.input.password.show': 'Afficher le mot de passe',
  'ui.input.password.hide': 'Masquer le mot de passe',
  // UI Modals
  'ui.modal.confirmation.title': `Êtes-vous sûr(e) de vouloir continuer ?`,
  'ui.modal.confirmation.irreversible': `Cette action est irréversible.`,

  //UI Informations
  'ui.information.extendable.yes': `...Plus`,
  'ui.information.extendable.no': `...Moins`,

  // More actions
  'moreActions.account.seeProfile': 'Voir le profil',
  'moreActions.account.logout': 'Se déconnecter',
  'moreActions.account.switchPlatform.admin': 'Aller vers la plateforme administrateur',
  'moreActions.account.switchPlatform.user': 'Aller vers la plateforme utilisateur',
  'moreActions.account.logout.confirmLabel': `Êtes-vous sûr de vouloir vous déconnecter ?`,
  'moreActions.session.seeDetails': 'Voir les détails',
  'moreActions.session.modify': 'Modifier la session',
  'moreActions.session.meetingLinkCopy': 'Copier le lien de la réunion',
  'moreActions.session.meetingLinkCopy.success': 'Lien copié !',
  'moreActions.session.addToCalendar': 'Ajouter à mon calendrier',
  'moreActions.session.cancel': 'Annuler la session',
  'moreActions.session.cancel.confirmLabel': `Êtes-vous sûr de vouloir annuler cette session ?`,
  'moreActions.session.cancel.success': `La session a été annulée avec succès !`,
  'moreActions.user.seeProfile': 'Voir le profil',
  'moreActions.user.sendMessage': 'Envoyer un message',
  'moreActions.user.edit': "Modifier l'utilisateur",
  'moreActions.user.sendInvitation': "Envoyer le lien d'invitation",
  'moreActions.user.sendInvitation.success': "Le lien d'invitation a été envoyé avec succès !",
  'moreActions.user.sendInvitation.sso':
    "Aucune invitation envoyée : ce compte se connecte par SSO. Pour qu'il se connecte avec un mot de passe, utilisez « Passer en e-mail + mot de passe ».",
  'moreActions.user.switchToPasswordLogin': 'Passer en e-mail + mot de passe',
  'moreActions.user.switchToPasswordLogin.confirmTitle': 'Passer ce compte en e-mail + mot de passe ?',
  'moreActions.user.switchToPasswordLogin.confirmLabel':
    'Ce compte ne se connectera plus par SSO. Il recevra un e-mail pour choisir son mot de passe.',
  'moreActions.user.switchToPasswordLogin.success':
    "Le compte se connecte maintenant par e-mail et mot de passe. L'invitation pour choisir le mot de passe est partie.",
  'moreActions.user.switchToPasswordLogin.successNoInvitation':
    "Le compte se connecte maintenant par e-mail et mot de passe, mais l'invitation n'a pas pu partir. Renvoyez-la avec « Envoyer le lien d'invitation ».",
  'moreActions.user.switchToPasswordLogin.alreadyPassword': 'Ce compte se connecte déjà par e-mail et mot de passe.',
  'moreActions.user.switchToPasswordLogin.emailLoginDisabled':
    'La connexion par e-mail et mot de passe est désactivée sur cette plateforme : seul le SSO fonctionne.',
  'moreActions.user.deleteFromProgram': 'Supprimer du programme',
  'moreActions.user.deleteFromProgram.confirmLabel': `Êtes-vous sûr de vouloir supprimer cet utilisateur du programme ?`,
  'moreActions.user.deleteFromProgram.success': `L'utilisateur a été supprimé du programme avec succès !`,
  'moreActions.admin.sessions.CSVExport': 'Exporter en CSV',
  'moreActions.admin.sessions.XLSXExport': 'Exporter en XLSX',
  'moreActions.admin.sessions.export.error': `Une erreur est survenue lors de l'export.`,
  'moreActions.admin.users.importFromExcel': 'Importer depuis un fichier Excel',
  'moreActions.admin.users.emailInvitation': `Inviter à partir d'un email`,
  'moreActions.system.resetDB.small': 'Réinitialiser la base de données (small)',
  'moreActions.system.resetDB.large': 'Réinitialiser la base de données (large)',
  'moreActions.system.resetDB.inProgress': 'Réinitialisation en cours...',
  'moreActions.system.resetDB.success': 'La base de données a été réinitialisée avec succès !',
  'moreActions.admin.groups.modifyStructure': 'Modifier la structure',
  'moreActions.admin.groups.modifySettings': 'Modifier les paramètres',
  'moreActions.admin.groups.delete': 'Supprimer le groupe',
  'moreActions.admin.groups.delete.confirmLabel': `Êtes-vous sûr de vouloir supprimer ce groupe ?`,
  'moreActions.admin.groups.delete.confirmContent': `Cette action est irréversible.<br/>Les données associées à ce groupe seront conservées (sessions, comptes-rendus, notes, etc.).`,

  // widgets
  'widget.nextSession.title': 'Prochaine session planifiée',
  'widget.nextSession.join': 'Rejoindre la session',
  'widget.nextSession.name': 'Session',
  'widget.nextSession.inProgress': 'En cours',

  // Common
  'common.mentor': '%*mentor*% | %*mentor*%s',
  'common.mentor.capitalize': `%*mentor*% | %*mentor*%s`,
  'common.mentee': '%*mentee*% | %*mentee*%s',
  'common.mentee.capitalize': `%*mentee*% | %*mentee*%s`,
  'common.manager': 'manager | managers',
  'common.manager.capitalize': `Manager | Managers`,
  'common.admin': 'admin | admins',
  'common.admin.capitalize': `Admin | Admins`,
  'common.support': 'support | supports',
  'common.support.capitalize': `Support | Supports`,
  'common.guest': 'invité | invités',
  'common.guest.capitalize': `Invité | Invités`,
  'common.program': 'programme | programmes',
  'common.program.capitalize': `Programme | Programmes`,
  'common.program.select': `Sélectionner un programme`,
  'common.group': 'groupe | groupes',
  'common.group.capitalize': `Groupe | Groupes`,
  'common.session': 'session | sessions',
  'common.session.capitalize': `Session | Sessions`,

  // fallbacks
  'fallback.mentee': 'mentoré',
  'fallback.mentor': 'mentor',

  // Errors
  'error.common': 'Une erreur est survenue',
  'error.userNotFound': 'Utilisateur non trouvé',
  'error.requiredNameField': 'Le nom est requis',
  'error.requiredEmailField': `L'email est requis`,
  'error.invalidEmail': `L'email est invalide`,
  'error.requiredRoleField': `Le rôle est requis`,
  'error.requiredFirstNameField': `Le prénom est requis`,
  'error.requiredLastNameField': `Le nom est requis`,
  'error.upload.tooLarge': `Fichier trop volumineux. Taille maximale : {maxSize}.`,
  'error.upload.unauthorized': `Votre session a expiré. Reconnectez-vous puis réessayez.`,
  'error.upload.serverError': `Le serveur de stockage est momentanément indisponible. Réessayez dans quelques instants.`,
  'error.upload.network': `Échec réseau pendant l'envoi. Vérifiez votre connexion puis réessayez.`,
  'error.upload.generic': `L'envoi du fichier a échoué. Réessayez.`,
  'error.upload.aborted': `Envoi annulé.`,

  // Impersonation
  'impersonation.banner.title': 'Mode Impersonation Actif',
  'impersonation.banner.description': `Vous êtes connecté en tant que {email}`,
  'impersonation.banner.stopButton': 'Revenir à mon compte',
  'impersonation.banner.stopping': 'Arrêt en cours...',
  'impersonation.banner.confirmStop': "Êtes-vous sûr de vouloir arrêter l'impersonation ?",
  'impersonation.banner.collapse': 'Réduire la bannière',
  'impersonation.action.start': 'Se connecter en tant que cet utilisateur',
  'impersonation.action.starting': 'Connexion en cours...',
  'impersonation.action.confirm': 'Voulez-vous vraiment vous connecter en tant que cet utilisateur ?',
  'impersonation.action.success': 'Connexion réussie, redirection en cours...',
  'impersonation.modal.title': 'Connexion au compte utilisateur',
  'impersonation.modal.message': 'Êtes-vous sûr de vouloir vous connecter au compte de {email} ?',
  'impersonation.modal.reasonLabel': "Raison de l'impersonation *",
  'impersonation.modal.selectReason': 'Sélectionnez une raison',
  'impersonation.modal.customReason': 'Autre raison (champ libre)',
  'impersonation.modal.customReasonLabel': 'Précisez la raison',
  'impersonation.modal.customReasonPlaceholder': 'Décrivez la raison de cette connexion...',
  'impersonation.modal.cancel': 'Annuler',
  'impersonation.modal.confirm': 'Confirmer la connexion',
  'impersonation.modal.confirming': 'Connexion en cours...',
  'impersonation.modal.errorRequired': 'Veuillez sélectionner ou saisir une raison',
  'impersonation.reasons.technicalSupport': 'Support technique',
  'impersonation.reasons.bugInvestigation': "Investigation d'un bug",
  'impersonation.reasons.userAssistance': 'Assistance utilisateur',
  'impersonation.reasons.dataVerification': 'Vérification des données',
  'impersonation.reasons.accountIssue': 'Problème de compte',

  // Error boundary (KC-466)
  'errorBoundary.title': 'Une erreur est survenue',
  'errorBoundary.description': `Quelque chose s'est mal passé sur cette page. Vous pouvez revenir à l'accueil pour continuer.`,
  'errorBoundary.goHome': `Revenir à l'accueil`,
  'legal.lastUpdated': `Dernière mise à jour : {date}`,
  'legal.notConfigured.title': 'Document en cours de configuration',
  'legal.notConfigured.body': `Les informations juridiques de cette plateforme ne sont pas encore renseignées. Merci de contacter l'administrateur.`,

  // Platform setup (assistant de mise en route d'une nouvelle plateforme)
  'ui.pageTitle.createPlatform': 'Créer la plateforme',
  'admin.setup.created.title': 'La plateforme {organization} est créée.',
  'admin.setup.created.description': `Vous en êtes l'administrateur. Cinq étapes pour la configurer, une dizaine de minutes : vos participants ne voient rien d'ici là.`,
  'admin.setup.create.eyebrow': 'Nouvelle plateforme',
  'admin.setup.create.title': 'Votre plateforme de mentorat est prête à être créée',
  'admin.setup.create.intro': `Elle n'a encore ni nom, ni couleurs, ni compte. Commencez par votre organisation et votre compte : vous en serez le premier administrateur.`,
  'admin.setup.create.steps.account': 'Votre compte administrateur',
  'admin.setup.create.steps.settings': 'Identité, apparence, connexion, RGPD',
  'admin.setup.create.steps.program': 'Votre premier programme',
  'admin.setup.create.formTitle': 'Créer la plateforme',
  'admin.setup.create.organization.label': 'Nom de votre organisation',
  'admin.setup.create.organization.placeholder': 'Par exemple : École Horizon',
  'admin.setup.create.organization.description': 'Votre école ou votre entreprise. Vous pourrez le modifier ensuite.',
  'admin.setup.create.firstname': 'Prénom',
  'admin.setup.create.lastname': 'Nom',
  'admin.setup.create.email': 'Votre e-mail professionnel',
  'admin.setup.create.password.label': 'Mot de passe',
  'admin.setup.create.password.description':
    '8 caractères minimum, avec une majuscule, une minuscule, un chiffre et un caractère spécial.',
  'admin.setup.create.submit': 'Créer la plateforme',
  'admin.setup.create.note': `Cet écran n'apparaît qu'une fois, tant que la plateforme n'a aucun compte. Vous accepterez ensuite les conditions d'utilisation.`,
  'admin.setup.create.errors.required': `Renseignez le nom de l'organisation, votre prénom et votre nom.`,
  'admin.setup.create.errors.email': `Cette adresse e-mail n'est pas valide.`,
  'admin.setup.create.errors.password': 'Le mot de passe ne respecte pas les règles indiquées sous le champ.',
  'admin.setup.create.errors.alreadyCreated': 'Cette plateforme a déjà été créée.',
  'admin.setup.create.errors.goToLogin': 'Se connecter',
  'admin.setup.create.errors.generic': `La création a échoué. Vérifiez votre connexion, puis réessayez.`,
  'admin.platform.edit': 'Modifier',
  'admin.platform.cancel': 'Annuler',
  'admin.platform.save': 'Enregistrer',
  'admin.platform.forbidden':
    'Ma plateforme est réservée aux super admins. Pour régler l’apparence, la connexion ou les e-mails, demandez au propriétaire de la plateforme de vous inviter comme super admin.',
  'admin.platform.close': 'Fermer',
  'admin.platform.sections.team.title': 'Super admins',
  'admin.platform.sections.team.description':
    'Accès à tous les programmes. Ils n’apparaissent pas dans les listes d’utilisateurs.',
  'admin.platform.sections.team.summary.active': '{count} super admin actif. | {count} super admins actifs.',
  'admin.platform.sections.team.summary.pending': '{count} invitation en attente. | {count} invitations en attente.',
  'admin.platform.sections.team.missing': 'Aucun super admin : invitez les personnes qui pilotent le mentorat.',
  'admin.platform.sections.team.note':
    'Le propriétaire ne peut pas être retiré. Une personne retirée est prévenue par e-mail. L’équipe Constel garde son accès d’assistance et n’apparaît pas ici.',
  'admin.platform.sections.team.noteMember':
    '{name} est propriétaire de la plateforme : seule cette personne peut transférer ce rôle. Vous ne pouvez ni la retirer, ni vous retirer vous-même.',
  'admin.platform.saved': 'Modifications enregistrées',
  'admin.platform.health.ok': 'Tout est en ordre.',
  'admin.platform.health.todo': '{count} point à compléter : | {count} points à compléter :',
  'admin.platform.sections.identity.title': 'Identité',
  'admin.platform.sections.identity.description': 'Le nom de la plateforme et de votre organisation',
  'admin.platform.sections.identity.summary': 'La plateforme s’appelle {title} et appartient à {company}.',
  'admin.platform.sections.identity.missing': 'Le nom de la plateforme ou de l’organisation manque.',
  'admin.platform.sections.branding.title': 'Apparence',
  'admin.platform.sections.branding.description':
    'L’aperçu suit chaque modification. Rien ne change pour vos participants avant « Enregistrer ».',
  'admin.platform.sections.branding.summary': 'Logo et couleurs. Texte blanc sur la couleur principale : {ratio}:1.',
  'admin.platform.sections.branding.missing': 'Aucune couleur principale définie.',
  'admin.platform.sections.login.title': 'Connexion',
  'admin.platform.sections.login.description': 'Comment vos participants entrent sur la plateforme',
  'admin.platform.sections.login.summary.both':
    'Vos participants se connectent avec le SSO de votre organisation ou avec leur e-mail et un mot de passe.',
  'admin.platform.sections.login.summary.sso': 'Vos participants se connectent avec le SSO de votre organisation.',
  'admin.platform.sections.login.summary.email': 'Vos participants se connectent avec leur e-mail et un mot de passe.',
  'admin.platform.sections.login.summary.none': 'Aucun moyen de connexion actif : personne ne peut se connecter.',
  'admin.platform.sections.support.title': 'Support',
  'admin.platform.sections.support.description': 'Qui répond à vos participants quand ils ont besoin d’aide',
  'admin.platform.sections.support.summary': 'Quand ils ont besoin d’aide, vos participants écrivent à {email}.',
  'admin.platform.sections.support.summaryWithPhone':
    'Quand ils ont besoin d’aide, vos participants écrivent à {email} ou appellent le {phone}.',
  'admin.platform.sections.support.missing': 'Aucun contact de support : vos participants ne savent pas à qui écrire.',
  'admin.platform.sections.resources.title': 'Ressources',
  'admin.platform.sections.resources.description': 'Le lien « Ressources » du menu de vos participants',
  'admin.platform.sections.resources.summary': 'Le lien « Ressources » du menu de vos participants mène à',
  'admin.platform.sections.resources.missing':
    'Aucun lien : l’entrée « Ressources » n’apparaît pas dans le menu de vos participants.',
  'admin.platform.sections.emails.title': 'E-mails',
  'admin.platform.sections.emails.description': 'Les e-mails que la plateforme envoie à vos participants',
  'admin.platform.sections.emails.summary.on':
    'La plateforme envoie ses e-mails automatiques : invitations, rappels de session, notifications.',
  'admin.platform.sections.emails.summary.off':
    'Les e-mails automatiques sont coupés : seules les invitations partent encore.',
  'admin.platform.sections.emails.toggle.title': 'Envoyer les e-mails automatiques',
  'admin.platform.sections.emails.toggle.description':
    'Rappels de session, notifications de messages, comptes rendus, mot de passe oublié. Les invitations partent dans tous les cas.',
  'admin.platform.sections.emails.warning':
    'Une fois coupés, vos participants ne recevront plus aucun rappel ni notification, et ne pourront plus réinitialiser leur mot de passe par e-mail. Seules les invitations partiront encore.',
  'admin.platform.sections.emails.confirm': 'Je confirme vouloir couper les e-mails automatiques',
  'admin.platform.sections.emails.errors.confirm': 'Cochez la confirmation pour couper les e-mails automatiques.',
  'admin.platform.sections.emails.soon': 'Bientôt ici : personnaliser le contenu des e-mails.',
  'admin.platform.sections.legal.title': 'Données personnelles',
  'admin.platform.sections.legal.description':
    'Responsable de traitement et DPO, repris dans la politique de confidentialité',
  'admin.platform.sections.legal.summary': '{company} est responsable des données. Son DPO répond à {dpo}.',
  'admin.platform.sections.legal.missing':
    'Le responsable de traitement ou le contact du DPO manque dans la politique de confidentialité.',
  'admin.platform.sections.legal.privacyLink': 'Lire la politique de confidentialité telle qu’elle s’affiche',
  'ui.pageTitle.adminSetup': 'Mise en route de la plateforme',
  'ui.layout.nav.platformSettings': 'Ma plateforme',
  'admin.setup.loading': 'Chargement des paramètres de la plateforme...',
  'admin.setup.errors.loading': `Impossible de charger les paramètres de la plateforme. Rechargez la page.`,
  'admin.setup.errors.save': `L'enregistrement a échoué. Vérifiez votre connexion, puis réessayez.`,
  'admin.setup.rail.ariaLabel': 'Étapes de la mise en route',
  'admin.setup.rail.title': 'Mise en route',
  'admin.setup.rail.subtitle': 'Votre plateforme de mentorat',
  'admin.setup.rail.autosave': `Chaque étape s'enregistre quand vous continuez`,
  'admin.setup.rail.later': 'Terminer plus tard',
  'admin.setup.rail.skipped': 'Passée, à reprendre',
  'admin.setup.stepCounter': 'Étape {current} sur {total}',
  'admin.setup.steps.identity.label': 'Identité',
  'admin.setup.steps.identity.hint': 'Nom et organisation',
  'admin.setup.steps.branding.label': 'Apparence',
  'admin.setup.steps.branding.hint': 'Logos et couleurs',
  'admin.setup.steps.login.label': 'Connexion',
  'admin.setup.steps.login.hint': 'Mot de passe ou SSO',
  'admin.setup.steps.contact.label': 'Contact et RGPD',
  'admin.setup.steps.contact.hint': 'Support et responsable',
  'admin.setup.steps.recap.label': 'Récapitulatif',
  'admin.setup.steps.recap.hint': 'Vérifier et terminer',
  'admin.setup.steps.team.label': 'Équipe',
  'admin.setup.steps.team.hint': 'Super admins',
  'admin.setup.team.title': 'Qui administre la plateforme avec vous ?',
  'admin.setup.team.intro':
    'Invitez les personnes de votre équipe qui pilotent le mentorat. Elles deviennent super admins de la plateforme.',
  'admin.setup.team.invite.label': 'Inviter un super admin',
  'admin.setup.team.invite.placeholder': "prenom.nom{'@'}organisation.fr",
  'admin.setup.team.invite.submit': 'Inviter',
  'admin.setup.team.invite.description':
    'Vous pouvez coller plusieurs adresses séparées par des virgules. Chacun reçoit un e-mail pour créer son compte.',
  'admin.setup.team.invite.descriptionSso':
    'Vous pouvez coller plusieurs adresses séparées par des virgules. Ils se connectent avec le SSO de votre organisation.',
  'admin.setup.team.list': 'Super admins de la plateforme',
  'admin.setup.team.you': '(vous)',
  'admin.setup.team.owner': 'Propriétaire',
  'admin.setup.team.constel': 'Équipe Constel',
  'admin.setup.team.transfer.open': 'Transférer la propriété',
  'admin.setup.team.transfer.title': 'Transférer la propriété',
  'admin.setup.team.transfer.description':
    'La personne choisie devient propriétaire de la plateforme. Vous restez super admin, et c’est elle qui pourra transférer ce rôle ensuite.',
  'admin.setup.team.transfer.candidates': 'Nouveau propriétaire',
  'admin.setup.team.transfer.empty':
    'Aucun super admin ne peut encore devenir propriétaire : invitez quelqu’un et attendez qu’il active son compte.',
  'admin.setup.team.transfer.pendingHint':
    'Seuls les super admins qui ont activé leur compte peuvent devenir propriétaires.',
  'admin.setup.team.transfer.confirmWord': 'TRANSFÉRER',
  'admin.setup.team.transfer.confirmLabel': 'Tapez {word} pour confirmer',
  'admin.setup.team.transfer.submit': 'Transférer',
  'admin.setup.team.transfer.submitTo': 'Transférer à {name}',
  'admin.setup.team.transfer.done': '{name} est maintenant propriétaire de la plateforme',
  'admin.setup.team.transfer.error': 'Le transfert a échoué. Réessayez.',
  'admin.setup.team.status.pending': 'En attente',
  'admin.setup.team.invitedAt': 'Invité {when}',
  'admin.setup.team.lastLogin': 'dernière connexion {when}',
  'admin.setup.team.neverLoggedIn': 'jamais connecté',
  'admin.setup.team.resend': 'Renvoyer',
  'admin.setup.team.remove.label': 'Retirer',
  'admin.setup.team.remove.cancelInvitation': 'Annuler',
  'admin.setup.team.remove.confirm': 'Confirmer le retrait',
  'admin.setup.team.remove.cancel': 'Garder',
  'admin.setup.team.invited': 'Invitation envoyée | {count} invitations envoyées',
  'admin.setup.team.resent': 'Invitation renvoyée à {email}',
  'admin.setup.team.removed': '{email} n’est plus super admin',
  'admin.setup.team.errors.empty': 'Saisissez au moins une adresse e-mail.',
  'admin.setup.team.errors.invalid': 'Adresse invalide : {emails}',
  'admin.setup.team.errors.failed': `Ces adresses n'ont pas pu être invitées : {emails}`,
  'admin.setup.team.errors.invite': `L'invitation a échoué. Vérifiez votre connexion, puis réessayez.`,
  'admin.setup.team.errors.resend': `L'invitation n'a pas pu être renvoyée.`,
  'admin.setup.team.errors.remove': `Le retrait a échoué. Réessayez.`,
  'admin.setup.team.errors.loading': 'Impossible de charger les super admins.',
  'admin.setup.team.about.title': 'Un super admin, c’est quelqu’un qui…',
  'admin.setup.team.about.allPrograms': 'a accès à tous les programmes, y compris ceux créés plus tard ;',
  'admin.setup.team.about.settings': 'règle la plateforme : apparence, connexion, e-mails ;',
  'admin.setup.team.about.impersonate': 'peut se connecter à la place d’un participant pour l’aider ;',
  'admin.setup.team.about.hidden':
    'n’apparaît pas dans la liste des utilisateurs des programmes, ni auprès des participants.',
  'admin.setup.team.about.oneProgram':
    'Pour donner la main sur un seul programme, invitez plutôt un administrateur ou un gestionnaire depuis ce programme.',
  'admin.setup.actions.back': 'Retour',
  'admin.setup.actions.skip': 'Passer cette étape',
  'admin.setup.actions.continue': 'Continuer',
  'admin.setup.identity.title': `Comment s'appelle votre plateforme ?`,
  'admin.setup.identity.intro': `Le nom que voient vos participants, et celui de votre organisation.`,
  'admin.setup.identity.company.label': 'Nom de votre organisation',
  'admin.setup.identity.company.description': 'Repris dans les mentions légales et dans la signature des e-mails.',
  'admin.setup.identity.platform.label': 'Nom de la plateforme',
  'admin.setup.identity.platform.description': `C'est ce que voient vos participants : onglet du navigateur, page de connexion, objet des e-mails.`,
  'admin.setup.branding.title': 'Mettez la plateforme à vos couleurs',
  'admin.setup.branding.intro': `L'aperçu change à chaque modification. Un programme pourra plus tard avoir ses propres couleurs.`,
  'admin.setup.branding.logos.title': 'Logo',
  'admin.setup.branding.logo.description': `PNG, JPG ou WebP, 2 Mo maximum. Carré de préférence : il sert aussi d'icône dans l'onglet du navigateur. Vous pouvez aussi glisser l'image sur la vignette.`,
  'admin.setup.branding.logo.choose': 'Choisir un fichier',
  'admin.setup.branding.logo.replace': 'Remplacer',
  'admin.setup.branding.logo.remove': 'Retirer',
  'admin.setup.branding.logo.uploading': 'Envoi du logo…',
  'admin.setup.branding.logo.errors.format': 'Ce format n’est pas accepté : choisissez une image PNG, JPG ou WebP.',
  'admin.setup.branding.logo.errors.size': 'L’image dépasse 2 Mo : réduisez-la puis réessayez.',
  'admin.setup.branding.logo.errors.upload': `L'envoi a échoué. Vérifiez votre connexion, puis réessayez.`,
  'admin.setup.branding.logo.default': 'Par défaut',
  'admin.setup.branding.website.label': 'Récupérer le logo et les couleurs depuis votre site',
  'admin.setup.branding.website.action': 'Récupérer',
  'admin.setup.branding.website.hint':
    'Collez l’adresse du site de votre organisation. Vous pourrez tout ajuster ensuite.',
  'admin.setup.branding.website.foundAll': 'Logo et couleurs récupérés. Vérifiez l’aperçu avant de continuer.',
  'admin.setup.branding.website.foundColors':
    'Couleurs récupérées. Aucun logo exploitable (PNG, JPG ou WebP) sur ce site : ajoutez-le depuis votre ordinateur.',
  'admin.setup.branding.website.foundLogo': 'Logo récupéré. Aucune couleur trouvée : choisissez-les ci-dessous.',
  'admin.setup.branding.website.nothing': `Rien d'exploitable sur ce site. Ajoutez le logo et les couleurs à la main.`,
  'admin.setup.branding.website.error': `La recherche sur ce site a échoué. Ajoutez le logo et les couleurs à la main.`,
  'admin.setup.branding.customStyle.title': 'Style personnalisé',
  'admin.setup.branding.customStyle.active': 'Un CSS personnalisé est appliqué à toutes les pages.',
  'admin.setup.branding.customStyle.label': 'CSS ajouté à toutes les pages',
  'admin.setup.branding.customStyle.warning':
    'Réservé aux ajustements fins. Ce CSS s’applique à toutes les pages, pour tous les participants, dès l’enregistrement : une erreur peut rendre la plateforme difficile à utiliser.',
  'admin.setup.branding.customStyle.description': 'Pour des ajustements fins en CSS. Facultatif.',
  'admin.setup.branding.customStyle.show': 'Afficher le CSS',
  'admin.setup.branding.customStyle.hide': 'Masquer le CSS',
  'admin.setup.branding.colors.title': 'Couleurs',
  'admin.setup.branding.primary.label': 'Couleur principale',
  'admin.setup.branding.secondary.label': 'Couleur secondaire',
  'admin.setup.branding.contrastOk': `Lisible : le texte blanc sur la couleur principale atteint {ratio}:1.`,
  'admin.setup.branding.preview.caption': 'Aperçu : la page de connexion de vos participants',
  'admin.setup.branding.preview.login': 'Connexion',
  'admin.setup.branding.preview.email': 'Adresse e-mail',
  'admin.setup.branding.preview.continue': 'Continuer',
  'admin.setup.branding.preview.help': `Besoin d'aide ?`,
  'admin.setup.branding.preview.support': 'Contacter le support',
  'admin.setup.login.title': 'Comment vos participants se connectent-ils ?',
  'admin.setup.login.intro': `Vous pouvez garder les deux : le SSO pour les participants de votre organisation, le mot de passe pour les mentors extérieurs.`,
  'admin.setup.login.email.title': 'Adresse e-mail et mot de passe',
  'admin.setup.login.email.description': 'Chaque participant reçoit une invitation et choisit son mot de passe.',
  'admin.setup.login.sso.title': 'SSO de votre organisation (SAML)',
  'admin.setup.login.sso.description':
    'Vos participants se connectent avec leur compte habituel : Microsoft Entra, Google, Shibboleth.',
  'admin.setup.login.sso.modeLegend': 'Qui configure le SSO ?',
  'admin.setup.login.sso.itTeam.title': `Ma DSI s'en occupe`,
  'admin.setup.login.sso.itTeam.description': `Vous lui envoyez les informations à déclarer. Le SSO reste désactivé tant que l'URL et le certificat ne sont pas renseignés.`,
  'admin.setup.login.sso.self.title': 'Je le configure maintenant',
  'admin.setup.login.sso.self.description': 'URL de connexion et certificat de votre fournisseur.',
  'admin.setup.login.sp.title': `À déclarer chez votre fournisseur d'identité`,
  'admin.setup.login.sp.entityId': 'Entity ID',
  'admin.setup.login.sp.callback': 'URL de retour (ACS)',
  'admin.setup.login.sp.mailto': `Préparer l'e-mail pour ma DSI`,
  'admin.setup.login.sp.subjectLabel': 'Objet',
  'admin.setup.login.sp.bodyLabel': 'Message',
  'admin.setup.login.sp.copy': 'Copier le message',
  'admin.setup.login.sp.copied': 'Message copié',
  'admin.setup.login.sp.openMailApp': 'Ouvrir dans ma messagerie',
  'admin.setup.login.sp.mailSubject': 'Configuration du SSO de la plateforme {platform}',
  'admin.setup.login.sp.mailBody': `Bonjour,\n\nNous mettons en place notre plateforme de mentorat, {platform}. Pour activer la connexion SSO (SAML), pouvez-vous déclarer cette application chez notre fournisseur d'identité ?\n\nEntity ID : {entityId}\nURL de retour (ACS) : {callback}\n\nEn retour, il nous faut l'URL de connexion SSO du fournisseur et son certificat X.509.\n\nMerci !`,
  'admin.setup.login.ssoLogo.label': 'Logo du bouton de connexion SSO',
  'admin.setup.login.ssoLogo.description': 'PNG, JPG ou WebP, 2 Mo maximum.',
  'admin.setup.login.ssoLogo.preview': 'Aperçu du bouton sur la page de connexion',
  'admin.setup.login.ssoLogo.default':
    'Par défaut, le bouton reprend le logo de la plateforme. Vous pouvez en mettre un autre, par exemple celui de votre fournisseur d’identité.',
  'admin.setup.login.ssoLogo.custom': 'Le bouton utilise un logo qui lui est propre.',
  'admin.setup.login.ssoLogo.choose': 'Utiliser un autre logo',
  'admin.setup.login.ssoLogo.reset': 'Revenir au logo de la plateforme',
  'admin.setup.login.idpUrl.label': 'URL de connexion du fournisseur (SSO URL)',
  'admin.setup.login.certificate.label': 'Certificat du fournisseur (X.509)',
  'admin.setup.login.certificate.description': 'Collez le certificat complet, lignes BEGIN et END comprises.',
  'admin.setup.login.errors.noMethod': `Gardez au moins un moyen de connexion actif : l'e-mail, ou un SSO dont l'URL et le certificat sont renseignés.`,
  'admin.setup.contact.title': 'Qui répond, et qui est responsable des données ?',
  'admin.setup.contact.support.title': 'Contact pour vos participants',
  'admin.setup.contact.support.description': `Affiché sous « Besoin d'aide ? » et en pied de chaque e-mail.`,
  'admin.setup.contact.supportEmail.label': 'E-mail de support',
  'admin.setup.contact.supportPhone.label': 'Téléphone, facultatif',
  'admin.setup.contact.resources.label': 'Lien vers vos ressources, facultatif',
  'admin.setup.contact.resources.description':
    'Un guide du mentor, un intranet. Il apparaît dans le menu des participants.',
  'admin.setup.contact.legal.title': 'Responsable de traitement',
  'admin.setup.contact.legal.description':
    'Exigé par le RGPD. Ces informations complètent la politique de confidentialité que vos participants acceptent.',
  'admin.setup.contact.rtName.label': 'Organisme',
  'admin.setup.contact.rtAddress.label': 'Adresse postale',
  'admin.setup.contact.dpoEmail.label': 'E-mail du DPO',
  'admin.setup.contact.legal.later': `Pas ces informations sous la main ? Passez l'étape. La plateforme reste utilisable, et ce point restera dans la checklist de votre tableau de bord.`,
  'admin.setup.recap.title': 'Votre plateforme est presque prête',
  'admin.setup.recap.titleDone': 'Votre plateforme est prête',
  'admin.setup.recap.intro': `Ce qui manque n'empêche pas de créer un programme. Il restera dans la checklist de votre tableau de bord.`,
  'admin.setup.recap.status.complete': 'Complet',
  'admin.setup.recap.status.todo': 'À compléter',
  'admin.setup.recap.edit': 'Modifier',
  'admin.setup.recap.next.title': 'Prochaine étape : votre premier programme',
  'admin.setup.recap.next.description': 'Dates, critères de matching, objectifs de session.',
  'admin.setup.recap.finish': 'Terminer sans programme',
  'admin.setup.recap.finishAndCreate': 'Terminer et créer un programme',
  'admin.setup.nav.title': 'Mise en route',
  'admin.setup.nav.progress': '{done} points sur {total}',
  'admin.setup.nav.remaining': 'Encore {count} point | Encore {count} points',
  'admin.setup.nav.done': 'Déjà réglé : {items}.',
  'admin.setup.checklist.items.identity': 'Nom et organisation',
  'admin.setup.checklist.items.branding': 'Logo et couleurs',
  'admin.setup.checklist.items.login': 'Moyen de connexion',
  'admin.setup.checklist.items.support': 'Contact de support',
  'admin.setup.checklist.items.legal': 'Responsable de traitement et DPO',
}
